(() => {
  const root = document.querySelector("[data-kob-makeup-arrival-control]");
  if (!root || !root.querySelector("[data-kob-mac-form]")) return;
  if (root.dataset.kobMacInitialized === "true") return;
  root.dataset.kobMacInitialized = "true";

  const endpoint = String(root.dataset.endpoint || "").replace(/\/$/, "");
  const refs = {
    form: root.querySelector("[data-kob-mac-form]"),
    releaseDraftForm: root.querySelector("[data-kob-mac-release-draft-form]"),
    inboxForm: root.querySelector("[data-kob-mac-inbox-form]"),
    documentUploadForm: root.querySelector("[data-kob-mac-document-upload-form]"),
    gmailSync: root.querySelector("[data-kob-mac-gmail-sync]"),
    gmailCandidates: root.querySelector("[data-kob-mac-gmail-candidates]"),
    gmailMore: root.querySelector("[data-kob-mac-gmail-more]"),
    gmailMoreWrap: root.querySelector("[data-kob-mac-gmail-more-wrap]"),
    inboxList: root.querySelector("[data-kob-mac-inbox-list]"),
    inboxDetail: root.querySelector("[data-kob-mac-inbox-detail]"),
    queueSearch: root.querySelector("[data-kob-mac-queue-search]"),
    queueFilter: root.querySelector("[data-kob-mac-queue-filter]"),
    queueCount: root.querySelector("[data-kob-mac-queue-count]"),
    queueScan: root.querySelector("[data-kob-mac-queue-scan]"),
    openUpload: root.querySelector("[data-kob-mac-open-upload]"),
    batchTitle: root.querySelector("[data-kob-mac-batch-title]"),
    batchMeta: root.querySelector("[data-kob-mac-batch-meta]"),
    batchNav: root.querySelector("[data-kob-mac-batch-nav]"),
    backToQueue: root.querySelector("[data-kob-mac-back-to-queue]"),
    catalog: root.querySelector("[data-kob-mac-catalog]"),
    catalogLinkBanner: root.querySelector("[data-kob-mac-catalog-link-banner]"),
    catalogLinkStatus: root.querySelector("[data-kob-mac-catalog-link-status]"),
    copyRelease: root.querySelector("[data-kob-mac-copy-release]"),
    copyReleaseButton: root.querySelector("[data-kob-mac-copy-release-button]"),
    email: root.querySelector("[data-kob-mac-email]"),
    alias: root.querySelector("[data-kob-mac-alias]"),
    token: root.querySelector("[data-kob-mac-token]"),
    load: root.querySelector("[data-kob-mac-load]"),
    refresh: root.querySelector("[data-kob-mac-refresh]"),
    preview: root.querySelector("[data-kob-mac-preview]"),
    record: root.querySelector("[data-kob-mac-record]"),
    inputRows: root.querySelector("[data-kob-mac-input-rows]"),
    previewPanel: root.querySelector("[data-kob-mac-preview-panel]"),
    previewRows: root.querySelector("[data-kob-mac-preview-rows]"),
    previewIssues: root.querySelector("[data-kob-mac-preview-issues]"),
    customerAllocations: root.querySelector("[data-kob-mac-customer-allocations]"),
    partnerAllocations: root.querySelector("[data-kob-mac-partner-allocations]"),
    history: root.querySelector("[data-kob-mac-history]"),
    prepareDrafts: root.querySelector("[data-kob-mac-prepare-drafts]"),
    createDrafts: root.querySelector("[data-kob-mac-create-drafts]"),
    sendInvoices: root.querySelector("[data-kob-mac-send-invoices]"),
    directInventory: root.querySelector("[data-kob-mac-direct-inventory]"),
    directForm: root.querySelector("[data-kob-mac-direct-form]"),
    directSelected: root.querySelector("[data-kob-mac-direct-selected]"),
    directPreview: root.querySelector("[data-kob-mac-direct-preview]"),
    directReserve: root.querySelector("[data-kob-mac-direct-reserve]"),
    directRequests: root.querySelector("[data-kob-mac-direct-requests]"),
    directStatus: root.querySelector("[data-kob-mac-direct-status]"),
    directNote: root.querySelector("[data-kob-mac-direct-note]"),
    draftGroups: root.querySelector("[data-kob-mac-draft-groups]"),
    draftStatus: root.querySelector("[data-kob-mac-draft-status]"),
    draftNote: root.querySelector("[data-kob-mac-draft-note]"),
    intakeTools: root.querySelector("[data-kob-mac-intake-tools]"),
    supplierStep: root.querySelector("[data-kob-mac-supplier-step]"),
    allocationSummary: root.querySelector("[data-kob-mac-allocation-summary]"),
    customerDialog: root.querySelector("[data-kob-mac-customer-dialog]"),
    customerDialogContent: root.querySelector("[data-kob-mac-customer-dialog-content]"),
    customerDialogClose: root.querySelector("[data-kob-mac-customer-close]"),
    progress: root.querySelector("[data-kob-mac-progress]"),
    nextTitle: root.querySelector("[data-kob-mac-next-title]"),
    nextCopy: root.querySelector("[data-kob-mac-next-copy]"),
    nextState: root.querySelector("[data-kob-mac-next-state]"),
    trackActions: root.querySelector("[data-kob-mac-track-actions]"),
    trackRefresh: root.querySelector("[data-kob-mac-track-refresh]"),
    startNext: root.querySelector("[data-kob-mac-start-next]"),
    releaseTitle: root.querySelector("[data-kob-mac-release-title]"),
    status: root.querySelector("[data-kob-mac-status]"),
    sendLock: root.querySelector("[data-kob-mac-send-lock]"),
    toast: root.querySelector("[data-kob-mac-toast]"),
    feedback: root.querySelector("[data-kob-mac-feedback]"),
  };
  const state = {
    supplierRows: [], recordedLines: [], batches: [], releases: [], inbox: [],
    selectedBatchId: "", activeInboxId: "", draftWritesEnabled: false,
    invoiceSendingEnabled: null, draftPlanStale: false, draftPlanRefreshBlocked: false,
    lastPlan: null, lastInvoicePlan: null, lastDraftPlan: null, requestId: "",
    selectedGroupIds: new Set(), loading: false, autoRefreshingDraftPlan: false, toastTimer: 0,
    allocations: [], productPreviews: {}, inboxProductPreviews: {}, workflowStage: 0,
    directPurchases: [], directPurchasePreview: null, directReservationRequestId: "",
    catalogLineId: "",
    gmailPageToken: "", gmailCandidateRows: [],
    batchTab: "invoice",
  };
  const arrivedAt = refs.form?.elements?.arrived_at;
  if (arrivedAt && !arrivedAt.value) arrivedAt.value = new Date().toISOString().slice(0, 10);
  const receivedAt = refs.inboxForm?.elements?.received_at;
  if (receivedAt && !receivedAt.value) receivedAt.value = new Date().toISOString().slice(0, 10);

  function authUrl(path) {
    const url = new URL(`${endpoint}${path}`);
    const values = { email: refs.email?.value || "", partner_alias: refs.alias?.value || "", partner_token: refs.token?.value || "" };
    Object.entries(values).forEach(([key, value]) => { if (value) url.searchParams.set(key, value); });
    return url.toString();
  }

  async function api(path, options = {}) {
    const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
    const response = await fetch(authUrl(path), {
      ...options,
      headers: { ...(isFormData ? {} : { "content-type": "application/json" }), ...(options.headers || {}) },
    });
    let payload;
    try { payload = await response.json(); } catch { payload = { ok: false, error: `HTTP ${response.status}` }; }
    if (!response.ok || !payload.ok) throw new Error(payload.detail || payload.error || `HTTP ${response.status}`);
    return payload;
  }

  async function catalogApi(path, options = {}) {
    const response = await fetch(`${endpoint}${path}`, {
      ...options,
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${refs.token?.value || ""}`,
        "x-kob-owner-email": refs.email?.value || "",
        "x-kob-owner-alias": refs.alias?.value || "",
        ...(options.headers || {}),
      },
    });
    let payload;
    try { payload = await response.json(); } catch { payload = { ok: false, error: `HTTP ${response.status}` }; }
    if (!response.ok || !payload.ok) throw new Error(payload.detail || payload.error || `HTTP ${response.status}`);
    return payload;
  }

  function releaseId() { return String(refs.form?.elements?.release_id?.value || "").trim(); }

  function invoiceReviewKind(row) {
    if (!row) return "";
    if (row.invoice_evidence_status !== "verified" || (row.parser_issues || []).length) return "evidence";
    return row.status === "review" ? "source" : "";
  }

  function selectBatchTab(tab, { allowUnrecorded = false } = {}) {
    const allowed = ["invoice", "receipt", "allocation", "payments", "remainder", "history"];
    if (!allowed.includes(tab)) return;
    const source = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
    const recorded = Boolean(state.selectedBatchId || source?.arrival_batch_id);
    const archived = source?.status === "rejected";
    if (archived && tab !== "invoice") return;
    if (!recorded && !allowUnrecorded && ["payments", "remainder", "history"].includes(tab)) return;
    state.batchTab = tab;
    root.dataset.tab = tab;
    refs.batchNav?.querySelectorAll("[data-batch-tab]").forEach((button) => {
      button.disabled = (archived && button.dataset.batchTab !== "invoice")
        || (!recorded && !allowUnrecorded && ["payments", "remainder", "history"].includes(button.dataset.batchTab));
      if (button.dataset.batchTab === tab) button.setAttribute("aria-current", "page");
      else button.removeAttribute("aria-current");
    });
  }

  function openBatchWorkspace(row, preferredTab = "") {
    if (!row) return;
    if (root.dataset.batchId !== row.inbox_id && refs.feedback) refs.feedback.hidden = true;
    root.dataset.batchId = row.inbox_id;
    root.dataset.view = "batch";
    if (refs.batchTitle) refs.batchTitle.textContent = row.invoice_number ? `Invoice ${row.invoice_number}` : (row.file_name || row.subject || "Arrival batch");
    if (refs.batchMeta) refs.batchMeta.textContent = [row.file_name || row.subject, row.received_at ? formatDate(row.received_at) : "", row.arrival_batch_id ? "Recorded arrival" : "Arrival review"].filter(Boolean).join(" · ");
    selectBatchTab(preferredTab || (row.arrival_batch_id ? "payments" : ["review", "rejected"].includes(row.status) ? "invoice" : row.receipt_review?.arrived_at ? "allocation" : "receipt"));
    const url = new URL(window.location.href);
    url.searchParams.set("inbox_id", row.inbox_id);
    window.history.replaceState(null, "", url);
  }

  function showArrivalQueue() {
    root.dataset.view = "queue";
    if (refs.feedback) refs.feedback.hidden = true;
    const url = new URL(window.location.href);
    url.searchParams.delete("inbox_id");
    window.history.replaceState(null, "", url);
    refs.queueSearch?.focus();
  }

  refs.batchNav?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-batch-tab]");
    if (button && !button.disabled) selectBatchTab(button.dataset.batchTab);
  });
  refs.backToQueue?.addEventListener("click", showArrivalQueue);
  refs.queueSearch?.addEventListener("input", renderInbox);
  refs.queueFilter?.addEventListener("change", renderInbox);
  refs.queueScan?.addEventListener("click", () => {
    if (refs.intakeTools) refs.intakeTools.open = true;
    if (refs.supplierStep) refs.supplierStep.open = true;
    refs.gmailSync?.click();
  });
  refs.openUpload?.addEventListener("click", () => {
    if (refs.intakeTools) refs.intakeTools.open = true;
    if (refs.supplierStep) refs.supplierStep.open = true;
    const manualIntake = root.querySelector(".kob-mac__manual-intake");
    if (manualIntake) manualIntake.open = true;
    refs.documentUploadForm?.querySelector('input[type="file"]')?.focus();
  });

  function draftGroupsCanBeCreated(groups = state.lastDraftPlan?.groups || []) {
    return groups.some((row) => (
      state.selectedGroupIds.has(row.group_id)
      && (row.status === "ready" || row.status === "prepared")
    ));
  }

  function selectedGroupsWithStatus(status) {
    return (state.lastDraftPlan?.groups || []).filter((row) => (
      state.selectedGroupIds.has(row.group_id) && row.status === status
    ));
  }

  function setWorkflowStage(stage, title, copy, stateLabel) {
    state.workflowStage = stage;
    root.dataset.workflowStage = String(stage);
    refs.progress?.querySelectorAll("[data-stage]").forEach((item) => {
      const itemStage = Number(item.dataset.stage || 0);
      item.classList.toggle("is-complete", itemStage < stage);
      item.classList.toggle("is-current", itemStage === stage);
    });
    if (refs.nextTitle) refs.nextTitle.textContent = title;
    if (refs.nextCopy) refs.nextCopy.textContent = copy;
    if (refs.nextState) refs.nextState.textContent = stateLabel;
    if (refs.trackActions) refs.trackActions.hidden = stage !== 6;
  }

  function updateWorkflowUI() {
    const paymentSummary = root.querySelector("[data-kob-mac-payment-summary]");
    if (paymentSummary) {
      const locale = (document.documentElement.lang || "en").slice(0, 2);
      const labels = ({zh:["付款状态未加载","正在读取付款状态","付款状态读取失败","付款状态需要复核","个链接","已发送","已付"],ja:["支払状況は未取得です","支払状況を取得中","支払状況を取得できません","支払状況の再確認が必要です","リンク","送信済み","支払済み"]})[locale]
        || ["Payment status not loaded","Loading payment status","Payment status unavailable","Payment status needs review","links","sent","paid"];
      const rows = (state.lastDraftPlan?.groups || []).filter(row => row.status !== "cancelled");
      const links = rows.filter(row => row.shopify_draft_order_id || row.invoice_url);
      paymentSummary.textContent = state.paymentReadFailed ? labels[2] : state.loading ? labels[1] : !state.lastDraftPlan ? labels[0]
        : state.draftPlanStale ? labels[3] : `${links.length} ${labels[4]} · ${rows.filter(row => row.status === "invoice_sent").length} ${labels[5]} · ${rows.filter(row => row.status === "completed").length} ${labels[6]}`;
    }
    const groups = state.lastDraftPlan?.groups || [];
    const activeGroups = groups.filter((row) => row.status !== "cancelled");
    const prepared = activeGroups.filter((row) => ["ready", "prepared"].includes(row.status));
    const created = activeGroups.filter((row) => row.status === "draft_created");
    const sent = activeGroups.filter((row) => ["invoice_sent", "completed"].includes(row.status));
    const selectedPrepared = prepared.filter((row) => state.selectedGroupIds.has(row.group_id));
    const selectedCreated = created.filter((row) => state.selectedGroupIds.has(row.group_id));
    const hasBatch = Boolean(state.selectedBatchId);
    const needsPaymentReview = hasBatch && (state.draftPlanStale || !activeGroups.length);

    refs.prepareDrafts.hidden = !(hasBatch && needsPaymentReview && !state.draftPlanRefreshBlocked);
    refs.createDrafts.hidden = !(hasBatch && !needsPaymentReview && prepared.length && (selectedPrepared.length || !selectedCreated.length));
    refs.sendInvoices.hidden = !(hasBatch && !needsPaymentReview && created.length && selectedCreated.length && !selectedPrepared.length);
    refs.prepareDrafts.textContent = state.draftPlanStale ? "Update payment review" : "Review payment requests";

    refs.prepareDrafts.disabled = state.loading || !hasBatch || state.draftPlanRefreshBlocked;
    refs.createDrafts.disabled = state.loading || !state.draftWritesEnabled || !draftGroupsCanBeCreated(activeGroups);
    refs.sendInvoices.disabled = state.loading || !state.invoiceSendingEnabled || !selectedGroupsWithStatus("draft_created").length;
    if (refs.sendLock) {
      const locale = (document.documentElement.lang || "en").slice(0, 2);
      const labels = ({zh:["正在核对发信权限","允许发送账单","账单发送已锁定"],ja:["送信可否を確認中","請求メール送信可能","請求メール送信はロック中"]})[locale] || ["Checking invoice sending availability","Invoice sending enabled","Invoice sending locked"];
      refs.sendLock.textContent = state.invoiceSendingEnabled === null ? labels[0] : state.invoiceSendingEnabled ? labels[1] : labels[2];
    }

    if (!hasBatch) {
      const selectedSource = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
      if (selectedSource?.status === "rejected") {
        setWorkflowStage(1, "Archived supplier source", "The original source and audit record are retained. Choose another batch from the queue to continue.", "No arrival recorded");
        return;
      }
      const openInvoice = state.inbox.find((row) => row.inbox_id === state.activeInboxId && !row.arrival_batch_id && row.status !== "rejected");
      const reviewKind = invoiceReviewKind(openInvoice);
      const receiptNeeded = openInvoice && !reviewKind && !openInvoice.receipt_review?.arrived_at;
      setWorkflowStage(
        !openInvoice ? 1 : reviewKind ? 2 : receiptNeeded ? 2 : 3,
        !openInvoice ? "Import a Miyazawa invoice" : reviewKind === "evidence" ? "Check the imported invoice" : reviewKind === "source" ? "Resolve product sources" : receiptNeeded ? "Confirm the physical receipt" : "Review the allocation",
        !openInvoice ? "Select an imported supplier email or import its PDF. Importing has no Shopify or email side effects."
          : reviewKind === "evidence" ? "Confirm the supplier document and tax-inclusive costs before continuing."
            : reviewKind === "source" ? "Choose a historical commitment or inventory source for each highlighted product line. Other lines need no change."
            : receiptNeeded ? "Enter the actual arrival date and the received quantities in Shanghai and Ariake."
              : "Review who receives the units and what remains before recording the arrival.",
        !openInvoice ? "Waiting for an invoice" : reviewKind === "evidence" ? "Invoice evidence needs review" : reviewKind === "source" ? "Product source needs review" : receiptNeeded ? "Physical count needed" : "Receipt saved",
      );
    } else if (needsPaymentReview) {
      setWorkflowStage(
        4,
        state.draftPlanRefreshBlocked ? "Payment review needs manual recovery" : "Update the payment review",
        state.draftPlanRefreshBlocked
          ? "An allocation changed after a Shopify payment link was created. Existing links are protected; review the affected request before continuing."
          : "The recorded allocation changed after the previous calculation. The review will be refreshed without creating Shopify payment links or sending email.",
        state.draftPlanRefreshBlocked ? "Protected payment link exists" : "Safe calculation only",
      );
    } else if (selectedCreated.length && !selectedPrepared.length) {
      setWorkflowStage(
        5,
        "Send the reviewed payment emails",
        state.invoiceSendingEnabled
          ? "Open each payment link if needed, then send the selected Shopify invoice emails."
          : "Payment links exist, but sending is locked at server level. Unlock sending only after the email summary and recipients are confirmed.",
        state.invoiceSendingEnabled ? `${selectedCreated.length} email${selectedCreated.length === 1 ? "" : "s"} selected` : "Email sending locked",
      );
    } else if (prepared.length) {
      setWorkflowStage(
        4,
        "Review each payment request",
        "Confirm each recipient, product and balance, then select the payment links to create.",
        `${prepared.length} request${prepared.length === 1 ? "" : "s"} ready for review`,
      );
    } else if (created.length) {
      setWorkflowStage(
        5,
        "Send the reviewed payment emails",
        state.invoiceSendingEnabled
          ? "Open each payment link if needed, then select the requests whose Shopify invoice emails should be sent."
          : "Payment links exist, but sending is locked at server level. Unlock sending only after the email summary and recipients are confirmed.",
        state.invoiceSendingEnabled ? `${created.length} email${created.length === 1 ? "" : "s"} ready` : "Email sending locked",
      );
    } else if (sent.length) {
      setWorkflowStage(
        6,
        "Track payment status",
        "The requests have been sent. Use the links and status records below to follow unpaid and completed balances.",
        `${sent.length} request${sent.length === 1 ? "" : "s"} sent`,
      );
    } else {
      setWorkflowStage(3, "Review the recorded allocation", "Confirm customer, partner and inventory quantities before preparing payment requests.", "Allocation recorded");
    }

    if (refs.draftNote) {
      if (state.draftPlanRefreshBlocked) {
        refs.draftNote.textContent = "Allocation changed after a Shopify payment link was created. Automatic refresh is blocked to protect the existing link.";
      } else if (state.draftPlanStale) {
        refs.draftNote.textContent = "Allocation changed after the last payment review. Updating this review does not create a Shopify Draft Order or send email.";
      } else if (selectedCreated.length && !selectedPrepared.length) {
        refs.draftNote.textContent = state.invoiceSendingEnabled
          ? "The selected Shopify payment links are ready to send."
          : "The selected Shopify payment links are ready, but email sending is locked by the server safety switch.";
      } else if (prepared.length) {
        refs.draftNote.textContent = "";
      } else if (created.length) {
        refs.draftNote.textContent = state.invoiceSendingEnabled
          ? "Shopify payment links are ready. Sending remains a separate, selected action."
          : "Shopify payment links are ready. Email sending is currently locked by the server safety switch.";
      } else if (sent.length) {
        refs.draftNote.textContent = "Payment emails have been sent. No further sending action is required.";
      } else {
        refs.draftNote.textContent = "";
      }
    }
  }

  async function loadOperations(inboxId = "") {
    try {
      const query = inboxId ? `?inbox_id=${encodeURIComponent(inboxId)}` : "";
      const payload = await api(`/makeup-operations/admin.json${query}`);
      Object.values(state.inboxProductPreviews).forEach((preview) => {
        if (preview?.object_url && preview.image_url) URL.revokeObjectURL(preview.image_url);
      });
      state.inboxProductPreviews = payload.selected_inbox_product_previews || {};
      state.releases = payload.releases || [];
      state.inbox = payload.inbox || [];
      renderReleaseHistory();
      renderInbox();
      updateWorkflowUI();
      return payload;
    } catch (error) {
      toast(`Unable to load Make Up inbox: ${error.message}`);
      return null;
    }
  }

  function resetArrivalWorkspace() {
    state.selectedBatchId = "";
    state.activeInboxId = "";
    state.supplierRows = [];
    state.recordedLines = [];
    state.allocations = [];
    state.directPurchases = [];
    state.directPurchasePreview = null;
    state.productPreviews = {};
    state.lastPlan = null;
    state.lastInvoicePlan = null;
    state.lastDraftPlan = null;
    state.selectedGroupIds = new Set();
    state.draftPlanStale = false;
    state.draftPlanRefreshBlocked = false;
    state.requestId = "";
    if (refs.form?.elements?.release_id) refs.form.elements.release_id.value = "";
    if (refs.inboxDetail) {
      refs.inboxDetail.hidden = true;
      refs.inboxDetail.innerHTML = "";
    }
    if (refs.inputRows) refs.inputRows.innerHTML = '<tr><td colspan="7">Import an invoice or load a manual source to begin.</td></tr>';
    if (refs.draftGroups) refs.draftGroups.innerHTML = "<p>No payment requests are available for the next arrival yet.</p>";
    if (refs.draftStatus) refs.draftStatus.textContent = "Waiting for a recorded arrival";
    if (refs.draftNote) refs.draftNote.textContent = "";
    if (refs.catalog) refs.catalog.innerHTML = "<p>Select a recorded arrival to prepare catalog product drafts.</p>";
    if (refs.directInventory) refs.directInventory.innerHTML = "<p>Record or open an arrival to offer its remaining inventory directly.</p>";
    if (refs.directRequests) refs.directRequests.innerHTML = "<p>No direct customer purchases in this arrival.</p>";
    if (refs.directForm) refs.directForm.hidden = true;
    if (refs.directStatus) refs.directStatus.textContent = "Waiting for a recorded arrival";
    renderDirectPurchases();
    if (refs.releaseTitle) refs.releaseTitle.textContent = "New arrival";
    if (refs.status) refs.status.textContent = "Waiting for supplier invoice";
    clearPreview();
    updateWorkflowUI();
  }

  async function startNextArrival() {
    resetArrivalWorkspace();
    await loadOperations();
    showArrivalQueue();
    if (refs.intakeTools) refs.intakeTools.open = true;
    if (refs.supplierStep) refs.supplierStep.open = true;
    refs.intakeTools?.scrollIntoView({ behavior: "smooth", block: "start" });
    toast("Ready for the next arrival. Earlier allocations, payment links and tracking history are preserved.");
  }

  function renderReleaseHistory() {
    if (!refs.copyRelease) return;
    const selected = refs.copyRelease.value;
    refs.copyRelease.innerHTML = '<option value="">Choose history</option>' + state.releases.map((release) => `<option value="${escapeHtml(release.release_id)}">${escapeHtml(release.release_id)} / ${escapeHtml(release.title || "")}</option>`).join("");
    if (state.releases.some((release) => release.release_id === selected)) refs.copyRelease.value = selected;
  }

  refs.copyReleaseButton?.addEventListener("click", async () => {
    const sourceReleaseId = refs.copyRelease?.value || "";
    if (!sourceReleaseId) return toast("Choose a previous release first.");
    setLoading(true);
    try {
      const payload = await api(`/makeup-operations/admin.json?release_id=${encodeURIComponent(sourceReleaseId)}`);
      const release = (payload.releases || []).find((item) => item.release_id === sourceReleaseId) || {};
      refs.releaseDraftForm.elements.release_id.value = sourceReleaseId;
      refs.releaseDraftForm.elements.title.value = release.title || sourceReleaseId;
      refs.releaseDraftForm.elements.supplier_deadline.value = String(release.supplier_deadline || "").slice(0, 10);
      refs.releaseDraftForm.elements.close_at.value = String(release.close_at || "").slice(0, 16);
      refs.releaseDraftForm.elements.lines.value = (payload.selected_release_lines || []).map((line) => [
        line.variant_code, line.product_title || "", line.official_price_jpy || 0,
        line.deposit_jpy || 5000, line.limited_pcs == null ? "" : line.limited_pcs,
      ].join(", ")).join("\n");
      toast("Previous release loaded. Change the release ID before saving if this is a new batch.");
    } catch (error) {
      toast(`Unable to load release history: ${error.message}`);
    } finally { setLoading(false); }
  });

  function renderInbox() {
    if (!refs.inboxList) return;
    const openCount = state.inbox.filter((row) => row.status !== "rejected" && !row.arrival_batch_id).length;
    const recordedCount = state.inbox.filter((row) => Boolean(row.arrival_batch_id)).length;
    const filter = refs.queueFilter?.value || "current";
    const archivedCount = state.inbox.filter((row) => row.status === "rejected").length;
    if (refs.queueCount) refs.queueCount.textContent = filter === "archived"
      ? `${archivedCount} archived source${archivedCount === 1 ? "" : "s"}`
      : `${openCount} need work · ${recordedCount} recorded`;
    const search = String(refs.queueSearch?.value || "").trim().toLowerCase();
    const visible = state.inbox.filter((row) => {
      const kind = row.status === "rejected" ? "archived" : row.arrival_batch_id ? "recorded" : "open";
      if (filter === "current" ? kind === "archived" : filter !== kind) return false;
      return !search || [row.invoice_number, row.delivery_note_number, row.file_name, row.subject, row.matched_release_id]
        .some((value) => String(value || "").toLowerCase().includes(search));
    });
    if (!visible.length) {
      refs.inboxList.innerHTML = `<p>${state.inbox.length ? "No batches match these filters." : "No supplier documents loaded."}</p>`;
      return;
    }
    const ordered = [...visible].sort((a, b) => {
      const rank = (row) => row.status === "rejected" ? 3 : row.arrival_batch_id ? 2 : row.status === "review" ? 0 : 1;
      return rank(a) - rank(b) || String(b.received_at || "").localeCompare(String(a.received_at || ""));
    });
    refs.inboxList.innerHTML = ordered.map((row) => {
      const matched = row.matched_release_id || "";
      const invoice = row.invoice_number ? `Invoice ${row.invoice_number}` : row.document_kind;
      const issueCount = (row.parser_issues || []).length;
      const recorded = Boolean(row.arrival_batch_id);
      const reviewKind = invoiceReviewKind(row);
      const stage = row.status === "rejected" ? "Archived source" : recorded ? "Recorded · payment / catalog" :
        reviewKind === "evidence" ? "Review invoice evidence" : reviewKind === "source" ? "Resolve product sources" :
          !row.receipt_review?.arrived_at ? "Confirm physical receipt" : "Review allocation";
      const detail = reviewKind === "source" ? "Check highlighted product lines"
        : reviewKind === "evidence" ? issueCount ? `${issueCount} document issue${issueCount === 1 ? "" : "s"}` : "Supplier evidence needs review"
          : matched || (recorded ? "Arrival recorded" : "Invoice verified");
      return `<article data-inbox-id="${escapeHtml(row.inbox_id)}"${state.activeInboxId === row.inbox_id ? ' class="is-active"' : ""}>
        <div><strong>${escapeHtml(row.file_name || row.subject || invoice || row.inbox_id)}</strong><span>${escapeHtml(formatDate(row.received_at))} · ${escapeHtml(invoice)}</span></div>
        <div><strong>${escapeHtml(stage)}</strong><span>${escapeHtml(detail)}</span></div>
        <div><button class="kob-mac-button" type="button" data-review-inbox>${recorded ? "Continue" : "Open batch"}</button></div>
      </article>`;
    }).join("");
  }

  function renderGmailCandidates() {
    if (!refs.gmailCandidates) return;
    const ordered = [...state.gmailCandidateRows].sort((a, b) =>
      String(b.received_at || "").localeCompare(String(a.received_at || "")));
    const pending = ordered.filter((row) => row.classification === "invoice_candidate" && !row.existing_inbox_id);
    const imported = ordered.filter((row) => row.existing_inbox_id);
    const other = ordered.filter((row) => row.classification !== "invoice_candidate" && !row.existing_inbox_id);
    const renderCandidate = (row) => {
      const importable = row.classification === "invoice_candidate" && !row.existing_inbox_id;
      const status = row.existing_inbox_id ? "Already imported" : row.classification === "invoice_candidate" ? "Invoice candidate" : "Not an arrival invoice";
      return `<article class="kob-mac__candidate${importable ? "" : " is-muted"}">
        <div><strong>${escapeHtml(row.file_name)}</strong><span>${escapeHtml(formatDate(row.received_at))} · ${escapeHtml(row.sender)}</span><small>${escapeHtml(row.subject)}</small><small>${escapeHtml(row.reason)}</small></div>
        <div><strong>${escapeHtml(status)}</strong>${row.existing_status ? `<span>${escapeHtml(row.existing_status)}</span>` : ""}</div>
        <div>${row.existing_inbox_id ? `<button class="kob-mac-button" type="button" data-open-existing="${escapeHtml(row.existing_inbox_id)}">Open batch</button>` :
          `<button class="kob-mac-button${importable ? " kob-mac-button--primary" : ""}" type="button" data-import-candidate data-message-id="${escapeHtml(row.message_id)}" data-attachment-index="${row.attachment_index}"${importable ? "" : " disabled"}>Import PDF</button>`}</div>
      </article>`;
    };
    const renderGroup = (rows, key, label) => rows.length
      ? `<details class="kob-mac__candidate-group" data-mail-group="${key}"><summary>${label} (${rows.length})</summary>${rows.map(renderCandidate).join("")}</details>` : "";
    refs.gmailCandidates.innerHTML = state.gmailCandidateRows.length
      ? `<p class="kob-mac__candidate-count"><strong>${pending.length} invoice PDF${pending.length === 1 ? "" : "s"} awaiting import</strong><span>Review each PDF before importing. Scanning does not record an arrival.</span></p>
        ${pending.length ? pending.map(renderCandidate).join("") : "<p>No unimported invoice PDFs in the scanned results.</p>"}
        ${renderGroup(imported, "imported", "Already imported")}${renderGroup(other, "other", "Other supplier PDFs · not arrival invoices")}`
      : "<p>No PDF candidates on this page.</p>";
    if (refs.gmailMoreWrap) refs.gmailMoreWrap.hidden = !state.gmailPageToken;
  }

  function renderInboxDetail(document, lines) {
    if (!refs.inboxDetail) return;
    refs.inboxDetail.hidden = false;
    const issues = document?.parser_issues || [];
    const recorded = Boolean(document?.arrival_batch_id);
    const rejected = document?.status === "rejected";
    const previous = state.inbox.find((row) => row.inbox_id === document?.revises_inbox_id);
    const revisionNotice = issues.includes("invoice_reference_already_imported")
      ? `<div class="kob-mac__revision"><strong>Possible corrected PDF</strong><span>This invoice reference already has a different PDF. Compare both originals before choosing the corrected file; a recorded arrival cannot be replaced.</span>${previous
        ? `<button class="kob-mac-button" type="button" data-accept-revision>Use this corrected PDF</button>`
        : "<span>Older source is outside the loaded queue. Review it before resolving this correction.</span>"}</div>` : "";
    const receipt = document?.receipt_review || {};
    const receiptByCode = new Map((receipt.lines || []).map((line) => [line.variant_code, line]));
    const allocationReviewed = Boolean(state.lastInvoicePlan && !(state.lastInvoicePlan.blocking_issues || []).length
      && document?.invoice_evidence_status === "verified" && receipt.arrived_at);
    const receiptForm = recorded || rejected ? "" : `<form class="kob-mac__receipt" data-receipt-form>
      <div class="kob-mac__receipt-head"><div><span class="kob-mac__eyebrow">2. Physical receipt</span><h3>Confirm what actually arrived</h3><p>Use the physical arrival date and count units in Shanghai and Ariake. A short delivery needs a reason; allocation uses the physical count.</p></div>
      <label><span>Physical arrival date</span><input name="arrived_at" type="date" value="${escapeHtml(receipt.arrived_at || "")}" required></label></div>
      ${(lines || []).map((line) => {
        const saved = receiptByCode.get(line.variant_code) || {};
        const reference = receiptReference(line.variant_code);
        return `<div class="kob-mac__receipt-line" data-receipt-line="${escapeHtml(line.variant_code)}">
          <div class="kob-mac__receipt-model" data-receipt-model-code="${escapeHtml(line.variant_code)}" data-supplier-title="${escapeHtml(line.product_title || "")}"><figure>${reference.image_url ? `<img src="${escapeHtml(reference.image_url)}" alt="" loading="lazy">` : "Exact reference image unavailable"}</figure><div><strong>${escapeHtml(line.variant_code)}</strong><span data-receipt-model-title>${escapeHtml(reference.title || line.product_title || "Supplier title pending")}</span><span class="kob-mac__invoice-qty">Invoice quantity <strong>${number(line.quantity)}</strong> unit${Number(line.quantity) === 1 ? "" : "s"}</span><small>${referenceNote(reference)}</small></div></div>
          <label><span>Shanghai</span><input data-receipt-shanghai type="number" min="0" max="${number(line.quantity)}" step="1" value="${saved.shanghai_qty ?? ""}" required></label>
          <label><span>Ariake</span><input data-receipt-ariake type="number" min="0" max="${number(line.quantity)}" step="1" value="${saved.ariake_qty ?? ""}" required></label>
          <label><span>Difference reason</span><input data-receipt-reason type="text" maxlength="500" value="${escapeHtml(saved.reason || "")}" placeholder="Only if the physical count differs"></label>
        </div>`;
      }).join("")}
      <div class="kob-mac__actions"><button class="kob-mac-button kob-mac-button--primary" type="submit">Save physical receipt</button></div>
    </form>`;
    const actions = recorded
      ? `<div class="kob-mac__actions"><button class="kob-mac-button kob-mac-button--primary" type="button" data-open-recorded data-arrival-batch-id="${escapeHtml(document.arrival_batch_id)}">Open recorded allocation and payments</button></div>`
      : rejected ? ""
        : `<div class="kob-mac__actions"><button class="kob-mac-button${allocationReviewed ? "" : " kob-mac-button--primary"}" type="button" data-preview-invoice>Review allocation</button><button class="kob-mac-button${allocationReviewed ? " kob-mac-button--primary" : ""}" type="button" data-record-invoice${allocationReviewed ? "" : " disabled"}>Confirm arrival and allocation</button></div>`;
    const archiveAction = recorded || rejected ? "" : `<details class="kob-mac__exception-actions"><summary>Other invoice actions</summary><button class="kob-mac-button" type="button" data-reject-invoice data-attachment-hash="${escapeHtml(document?.attachment_hash || "")}">Mark as non-invoice</button></details>`;
    const archiveMessage = rejected ? `<p class="kob-mac__document-issues">${document?.document_kind === "superseded_invoice" ? "This invoice was superseded by a corrected PDF." : "This source is not an arrival invoice."} Its original and audit record are retained.</p>` : "";
    const savedReceipt = recorded && receipt.arrived_at ? `<div class="kob-mac__saved-receipt"><strong>Physical receipt confirmed · ${escapeHtml(receipt.arrived_at)}</strong><p>These quantities were locked when the arrival was recorded.</p>${(receipt.lines || []).map((line) => `<span>${escapeHtml(line.variant_code)} · Shanghai ${number(line.shanghai_qty)} · Ariake ${number(line.ariake_qty)}</span>`).join("")}</div>` : "";
    refs.inboxDetail.innerHTML = `<div data-batch-panel="invoice">${archiveMessage}${issues.length ? `<p class="kob-mac__document-issues">Document check: ${escapeHtml(issues.join(" / "))}</p>` : ""}
      <div class="kob-mac__document-summary">
        <div><span>Invoice</span><strong>${escapeHtml(document?.invoice_number || "-")}</strong></div>
        <div><span>Delivery note</span><strong>${escapeHtml(document?.delivery_note_number || "-")}</strong></div>
        <div><span>Tax included</span><strong>JPY ${number(document?.total_jpy)}</strong></div>
        <div><span>Document check</span><strong>${escapeHtml(document?.parser_status || "review")}</strong></div>
      </div>
      ${document?.raw_object_key ? `<div class="kob-mac__source-document"><span>Check the item code against the delivery-note page before changing it. Similar letters and digits are suggestions only.</span><button class="kob-mac-button" type="button" data-open-supplier-pdf>View original PDF</button></div>` : ""}
      ${revisionNotice}
      ${archiveAction}
      <div>${(lines || []).map((line) => {
        const candidates = (line.match_candidates || []).map((item) => item.release_id).filter(Boolean);
        const releaseOptions = candidates.map((release) => `<option value="release:${escapeHtml(release)}"${line.match_source === "operational_release" && line.matched_release_id === release ? " selected" : ""}>Preorder ${escapeHtml(release)}</option>`).join("");
        const selectedLegacy = line.match_source === "legacy" ? " selected" : "";
        const selectedInventory = line.match_source === "inventory" ? " selected" : "";
        return `<article class="kob-mac__document-line${line.match_status === "review" ? " kob-mac__document-line--review" : ""}" data-inbox-line="${escapeHtml(line.variant_code)}">
          <div><strong>${escapeHtml(line.variant_code)} / ${escapeHtml(line.product_title || "")}</strong><span>JAN ${escapeHtml(line.jan_code || "not printed")} · Ex-tax JPY ${number(line.unit_cost_ex_tax_jpy)} / tax-inclusive JPY ${number(line.tax_inclusive_unit_cost_jpy)}</span>
            ${(line.code_suggestions || []).length ? `<p class="kob-mac__code-hint">Check the original PDF: ${line.code_suggestions.map((item) => `<button type="button" data-suggest-code="${escapeHtml(item.variant_code)}">${escapeHtml(item.variant_code)}</button> (${escapeHtml(item.sources.join(" / "))})`).join(" · ")}</p>` : ""}
            ${!recorded && !rejected && document?.raw_object_key ? `<details class="kob-mac__code-correction"><summary>Correct a misread code</summary><p>Read the exact code on the original PDF. This updates this invoice line and recalculates its order source; it does not record an arrival.</p><label>Correct code<input data-correct-code type="text" maxlength="80" value="${escapeHtml(line.variant_code)}" autocomplete="off" spellcheck="false"></label><label>PDF page<input data-correct-page type="number" min="1" max="100" value="${Number(line.payload?.source_page) > 0 ? number(line.payload.source_page) : ""}" placeholder="Page number"></label><label>What you verified<input data-correct-reason type="text" maxlength="300" placeholder="e.g. Code and JAN on delivery note" autocomplete="off"></label><label class="kob-mac__code-confirm"><input data-correct-verified type="checkbox">I checked the original PDF</label><button class="kob-mac-button" type="button" data-correct-line-code>Save code and recalculate source</button></details>` : ""}</div>
          <div><span>Invoiced</span><strong>${number(line.quantity)}</strong></div>
          <div><span>Customer due</span><strong>${number(line.outstanding_customer_qty)}</strong></div>
          <div><span>Partner due</span><strong>${number(line.outstanding_partner_qty)}</strong></div>
          <div><span>${line.match_status === "review" ? "Source needs review" : `Source: ${escapeHtml(line.match_source || "")}`}</span><details class="kob-mac__source-decision"${line.match_status === "review" && !recorded && !rejected ? " open" : ""}><summary>${line.match_status === "review" ? "Choose source" : "Review source details"}</summary><select data-line-match aria-label="${escapeHtml(line.variant_code)} source"${rejected || recorded ? " disabled" : ""}><option value="review"${line.match_status === "review" ? " selected" : ""}>Needs review</option>${releaseOptions}<option value="legacy"${selectedLegacy}>Legacy commitments (${number(line.legacy_commitment_count)})</option><option value="inventory"${selectedInventory}>Inventory / no commitment</option></select><input data-line-reason type="text" maxlength="500" value="${escapeHtml(line.match_reason || "")}" placeholder="Reason if assigning inventory" aria-label="${escapeHtml(line.variant_code)} inventory reason"${rejected || recorded ? " disabled" : ""}><button class="kob-mac-button" type="button" data-save-line-match${rejected || recorded ? " disabled" : ""}>Save source</button></details></div>
        </article>`;
      }).join("")}</div></div>
      <div data-batch-panel="receipt">${receiptForm || savedReceipt || `<p class="kob-mac__document-issues">No physical receipt is available for this source.</p>`}</div>
      <div data-batch-panel="allocation">${rejected ? "" : `<div class="kob-mac__allocation-intro"><h3>${recorded ? "Recorded allocation" : "Review before recording"}</h3><p>${recorded ? "The saved quantities are fixed. Open the recorded allocation below to review payment work." : "Review the proposed customer, partner and remainder quantities. Previewing does not record stock or create a Shopify payment link."}</p></div>`}${actions}</div>`;
    if (!recorded && !rejected) hydrateProductPreviews((lines || []).map((line) => line.variant_code));
  }

  function parseLineText(value, mapper) {
    return String(value || "").split(/\r?\n/).map((line) => line.trim()).filter(Boolean).map((line) => mapper(line.split(",").map((part) => part.trim()))).filter(Boolean);
  }

  refs.releaseDraftForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = new FormData(refs.releaseDraftForm);
    const lines = parseLineText(form.get("lines"), (cells) => cells[0] ? ({
      variant_code: cells[0], product_title: cells[1] || "", official_price_jpy: cells[2] || 0,
      deposit_jpy: cells[3] || 5000, limited_pcs: cells[4] || "",
    }) : null);
    if (!lines.length) return toast("Add at least one preorder product line.");
    setLoading(true);
    try {
      const payload = await api("/makeup-operations/release-draft", { method: "POST", body: JSON.stringify({
        release_id: form.get("release_id"), title: form.get("title"), supplier_deadline: form.get("supplier_deadline"),
        close_at: form.get("close_at"), source_type: "manual", lines,
      }) });
      await loadOperations();
      toast(`Release draft saved: ${payload.line_count} products. No Shopify products were created.`);
    } catch (error) {
      toast(`Release draft failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.inboxForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = new FormData(refs.inboxForm);
    const lines = parseLineText(form.get("lines"), (cells) => cells[0] ? ({
      variant_code: cells[0], quantity: cells[1] || 0, tax_inclusive_unit_cost_jpy: cells[2] || 0,
      product_title: cells.slice(3).join(", "),
    }) : null);
    if (!lines.length) return toast("Add at least one incoming product line.");
    setLoading(true);
    try {
      const payload = await api("/makeup-operations/supplier-inbox", { method: "POST", body: JSON.stringify({
        subject: form.get("subject"), message_id: form.get("message_id"), received_at: form.get("received_at"),
        document_kind: form.get("document_kind"), source_type: "manual", lines,
        supplier_account: form.get("supplier_account"), invoice_number: form.get("invoice_number"),
        delivery_note_number: form.get("delivery_note_number"), document_date: form.get("document_date"),
        currency: "JPY", subtotal_jpy: form.get("subtotal_jpy"), tax_jpy: form.get("tax_jpy"),
        total_jpy: form.get("total_jpy"),
      }) });
      await loadOperations(payload.inbox_id || "");
      toast(payload.duplicate ? "This supplier document was already imported." : (payload.matched_release_id ? `Matched to ${payload.matched_release_id}. No arrival recorded yet.` : "Saved for review. Choose the matching release."));
    } catch (error) {
      toast(`Supplier inbox import failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  async function scanSupplierMail(pageToken = "") {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (pageToken) params.set("page_token", pageToken);
      const payload = await api(`/makeup-operations/gmail-candidates?${params}`);
      state.gmailCandidateRows = pageToken ? [...state.gmailCandidateRows, ...(payload.candidates || [])] : (payload.candidates || []);
      state.gmailPageToken = payload.next_page_token || "";
      renderGmailCandidates();
      refs.gmailCandidates?.scrollIntoView({ behavior: "smooth", block: "start" });
      toast(`${payload.candidates?.length || 0} PDF attachment${payload.candidates?.length === 1 ? "" : "s"} found on this page. Scanning saved nothing.`);
    } catch (error) {
      toast(`Mail scan failed: ${error.message}`);
    } finally { setLoading(false); }
  }

  refs.gmailSync?.addEventListener("click", () => scanSupplierMail());
  refs.gmailMore?.addEventListener("click", () => scanSupplierMail(state.gmailPageToken));

  refs.gmailCandidates?.addEventListener("click", async (event) => {
    const existing = event.target.closest("[data-open-existing]");
    if (existing) {
      const button = refs.inboxList?.querySelector(`[data-inbox-id="${CSS.escape(existing.dataset.openExisting || "")}"] [data-review-inbox]`);
      if (button) button.click();
      else toast("This older batch is outside the loaded queue. Refresh the queue before opening it.");
      return;
    }
    const button = event.target.closest("[data-import-candidate]");
    if (!button) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-operations/gmail-import", { method: "POST", body: JSON.stringify({
        message_id: button.dataset.messageId, attachment_index: Number(button.dataset.attachmentIndex),
      }) });
      const operations = await loadOperations(payload.inbox_id || "");
      const row = (operations?.inbox || []).find((item) => item.inbox_id === payload.inbox_id);
      if (row && !row.arrival_batch_id) resetArrivalWorkspace();
      state.activeInboxId = payload.inbox_id || "";
      renderInboxDetail(row, operations?.selected_inbox_lines || []);
      openBatchWorkspace(row, "receipt");
      state.gmailCandidateRows = state.gmailCandidateRows.map((item) => item.message_id === button.dataset.messageId
        && item.attachment_index === Number(button.dataset.attachmentIndex)
        ? { ...item, existing_inbox_id: payload.inbox_id, existing_status: row?.status || "review" } : item);
      renderGmailCandidates();
      renderInbox();
      updateWorkflowUI();
      toast(payload.duplicate ? "This PDF was already imported. Open its batch to continue." :
        `Imported ${payload.line_count} product lines. Confirm the physical receipt before recording.`);
    } catch (error) {
      toast(`PDF import failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.documentUploadForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = new FormData(refs.documentUploadForm);
    setLoading(true);
    try {
      const payload = await api("/makeup-operations/document-import", { method: "POST", body: form });
      const operations = await loadOperations(payload.inbox_id || "");
      const row = (operations?.inbox || []).find((item) => item.inbox_id === payload.inbox_id);
      state.activeInboxId = payload.inbox_id || "";
      renderInboxDetail(row, operations?.selected_inbox_lines || []);
      openBatchWorkspace(row, "receipt");
      toast(payload.duplicate ? "This PDF was already imported." : `PDF imported: ${payload.line_count} product lines. Review highlighted matches.`);
    } catch (error) {
      toast(`PDF import failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.inboxList?.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-review-inbox]");
    if (!button) return;
    const article = button.closest("[data-inbox-id]");
    const inboxId = article?.dataset.inboxId || "";
    if (!inboxId) return;
    setLoading(true);
    try {
      const payload = await loadOperations(inboxId);
      const row = state.inbox.find((item) => item.inbox_id === inboxId);
      if (row && !row.arrival_batch_id) resetArrivalWorkspace();
      state.activeInboxId = inboxId;
      renderInbox();
      renderInboxDetail(row, payload?.selected_inbox_lines || []);
      openBatchWorkspace(row);
      if (row?.arrival_batch_id) {
        await load(row.arrival_batch_id);
        toast("Recorded arrival restored. Existing allocations and payment status were preserved.");
      } else {
        updateWorkflowUI();
        const reviewKind = invoiceReviewKind(row);
        toast(row?.status === "rejected" ? "Archived source opened. Its original and audit record are retained."
          : reviewKind === "evidence" ? "Invoice opened. Review its supplier evidence before recording."
            : reviewKind === "source" ? "Invoice opened. Resolve highlighted product sources before recording."
            : row?.receipt_review?.arrived_at ? "Physical receipt saved. Review allocation before recording."
              : "Invoice opened. Confirm the actual arrival date and quantities in both locations.");
      }
    } catch (error) {
      toast(`Unable to load supplier document: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.inboxDetail?.addEventListener("submit", async (event) => {
    const form = event.target.closest("[data-receipt-form]");
    if (!form || !state.activeInboxId) return;
    event.preventDefault();
    const source = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
    const lines = [...form.querySelectorAll("[data-receipt-line]")].map((row) => ({
      variant_code: row.dataset.receiptLine,
      shanghai_qty: row.querySelector("[data-receipt-shanghai]")?.value,
      ariake_qty: row.querySelector("[data-receipt-ariake]")?.value,
      reason: row.querySelector("[data-receipt-reason]")?.value.trim() || "",
    }));
    setLoading(true);
    try {
      await api("/makeup-operations/receipt-review", { method: "POST", body: JSON.stringify({
        inbox_id: state.activeInboxId, expected_attachment_hash: source?.attachment_hash,
        expected_updated_at: source?.updated_at,
        arrived_at: form.elements.arrived_at.value, lines,
      }) });
      state.lastInvoicePlan = null;
      const payload = await loadOperations(state.activeInboxId);
      renderInboxDetail(state.inbox.find((row) => row.inbox_id === state.activeInboxId), payload?.selected_inbox_lines || []);
      toast("Physical receipt saved. Review allocation with these counts before recording.");
    } catch (error) {
      toast(`Physical receipt could not be saved: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.inboxDetail?.addEventListener("click", async (event) => {
    const pdfButton = event.target.closest("[data-open-supplier-pdf]");
    if (pdfButton && state.activeInboxId) {
      const previewWindow = window.open("", "_blank");
      try {
        const response = await fetch(authUrl(`/makeup-operations/supplier-pdf?inbox_id=${encodeURIComponent(state.activeInboxId)}`), { cache: "no-store" });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const objectUrl = URL.createObjectURL(await response.blob());
        if (previewWindow) previewWindow.location.href = objectUrl;
        else {
          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = "supplier-invoice.pdf";
          link.click();
        }
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 300000);
      } catch (error) {
        previewWindow?.close();
        toast(`Original PDF could not be opened: ${error.message}`);
      }
      return;
    }
    const suggestion = event.target.closest("[data-suggest-code]");
    if (suggestion) {
      const article = suggestion.closest("[data-inbox-line]");
      const details = article?.querySelector(".kob-mac__code-correction");
      const input = article?.querySelector("[data-correct-code]");
      if (input) { details.open = true; input.value = suggestion.dataset.suggestCode || ""; input.focus(); }
      return;
    }
    const correctionButton = event.target.closest("[data-correct-line-code]");
    if (correctionButton && state.activeInboxId) {
      const article = correctionButton.closest("[data-inbox-line]");
      const fromCode = article?.dataset.inboxLine || "";
      const toCode = article?.querySelector("[data-correct-code]")?.value.trim().toUpperCase() || "";
      const sourcePage = Number(article?.querySelector("[data-correct-page]")?.value);
      const reason = article?.querySelector("[data-correct-reason]")?.value.trim() || "";
      const checked = article?.querySelector("[data-correct-verified]")?.checked;
      const document = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
      if (!checked) return toast("Open the original PDF and confirm the printed code before saving.");
      if (!fromCode || !/^[A-Z0-9-]{3,80}$/.test(toCode) || fromCode === toCode || !Number.isInteger(sourcePage) || sourcePage < 1 || !reason) {
        return toast("Enter a different exact code, PDF page and what you verified.");
      }
      if (!window.confirm(`Correct this invoice line from ${fromCode} to ${toCode} using the original PDF page ${sourcePage}? Its source match and preview will be recalculated.`)) return;
      setLoading(true);
      try {
        const saved = await api("/makeup-operations/supplier-line-code-correction", { method: "POST", body: JSON.stringify({
          inbox_id: state.activeInboxId, from_code: fromCode, to_code: toCode,
          expected_attachment_hash: document?.attachment_hash,
          expected_updated_at: document?.updated_at,
          source_page: sourcePage, reason,
          confirmation: "CORRECT SUPPLIER CODE",
        }) });
        state.lastInvoicePlan = null;
        const operations = await loadOperations(state.activeInboxId);
        renderInboxDetail(state.inbox.find((row) => row.inbox_id === state.activeInboxId), operations?.selected_inbox_lines || []);
        selectBatchTab("invoice");
        toast(`${saved.variant_code} saved · ${saved.match_source === "legacy" ? `${saved.legacy_commitment_count} legacy orders found` : saved.match_status === "review" ? "source still needs review" : "source recalculated"}. Review allocation again before recording.`);
      } catch (error) { toast(`Code correction failed: ${error.message}`); }
      finally { setLoading(false); }
      return;
    }
    const openRecordedButton = event.target.closest("[data-open-recorded]");
    if (openRecordedButton) {
      await load(openRecordedButton.dataset.arrivalBatchId || "");
      return;
    }
    const revisionButton = event.target.closest("[data-accept-revision]");
    if (revisionButton && state.activeInboxId) {
      const revised = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
      const previous = state.inbox.find((row) => row.inbox_id === revised?.revises_inbox_id);
      if (!previous) return toast("Open and review the older invoice before accepting this correction.");
      const reason = window.prompt("Why should this PDF replace the earlier unrecorded invoice? Compare the source files first.");
      if (!reason?.trim()) return;
      const confirmation = window.prompt('Type USE REVISED INVOICE to archive the earlier PDF and use this one.');
      if (confirmation !== "USE REVISED INVOICE") return;
      setLoading(true);
      try {
        await api("/makeup-operations/invoice-revision", { method: "POST", body: JSON.stringify({
          previous_inbox_id: previous.inbox_id, revised_inbox_id: revised.inbox_id,
          expected_previous_hash: previous.attachment_hash, expected_revised_hash: revised.attachment_hash,
          reason: reason.trim(), confirmation,
        }) });
        state.lastInvoicePlan = null;
        const payload = await loadOperations(revised.inbox_id);
        renderInboxDetail(state.inbox.find((row) => row.inbox_id === revised.inbox_id), payload?.selected_inbox_lines || []);
        toast("Earlier PDF archived with an audit record. Review the corrected invoice and physical receipt.");
      } catch (error) { toast(`Correction could not be accepted: ${error.message}`); }
      finally { setLoading(false); }
      return;
    }
    const rejectButton = event.target.closest("[data-reject-invoice]");
    if (rejectButton && state.activeInboxId) {
      const reason = window.prompt("Why is this source not a Miyazawa arrival invoice? The original and audit record will be retained.");
      if (!reason?.trim()) return;
      const confirmation = window.prompt('Type REJECT NON-INVOICE to mark this source as non-invoice.');
      if (confirmation !== "REJECT NON-INVOICE") return;
      setLoading(true);
      try {
        await api("/makeup-operations/invoice-reject", { method: "POST", body: JSON.stringify({
          inbox_id: state.activeInboxId, expected_attachment_hash: rejectButton.dataset.attachmentHash,
          reason: reason.trim(), confirmation,
        }) });
        state.lastInvoicePlan = null;
        const operations = await loadOperations(state.activeInboxId);
        renderInboxDetail(state.inbox.find((item) => item.inbox_id === state.activeInboxId), operations?.selected_inbox_lines || []);
        selectBatchTab("invoice");
        toast("Marked as non-invoice. The source and audit record remain available.");
      } catch (error) {
        toast(`Unable to mark non-invoice: ${error.message}`);
      } finally { setLoading(false); }
      return;
    }
    const previewButton = event.target.closest("[data-preview-invoice]");
    if (previewButton && state.activeInboxId) {
      setLoading(true);
      try {
        const payload = await api("/makeup-operations/invoice-preview", { method: "POST", body: JSON.stringify({ inbox_id: state.activeInboxId }) });
        state.lastInvoicePlan = payload.plan;
        renderInvoicePlan(payload.plan);
        const recordButton = refs.inboxDetail.querySelector("[data-record-invoice]");
        if (recordButton) {
          const source = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
          recordButton.disabled = Boolean((payload.plan.blocking_issues || []).length || !source?.receipt_review?.arrived_at || source?.invoice_evidence_status !== "verified");
          recordButton.classList.toggle("kob-mac-button--primary", !recordButton.disabled);
        }
        previewButton.classList.toggle("kob-mac-button--primary", Boolean(recordButton?.disabled));
        toast(payload.plan.blocking_issues?.length ? "Preview loaded. Resolve highlighted document matches before recording." : "Complete invoice allocation preview loaded. No invoices were sent.");
      } catch (error) {
        toast(`Invoice preview failed: ${error.message}`);
      } finally { setLoading(false); }
      return;
    }
    const recordButton = event.target.closest("[data-record-invoice]");
    if (recordButton && state.activeInboxId) {
      if (!state.lastInvoicePlan) return toast("Preview the complete allocation before recording.");
      if ((state.lastInvoicePlan.blocking_issues || []).length) return toast("Resolve the document and source matches before recording.");
      if (!window.confirm("Record this complete Miyazawa invoice and reserve its customer and partner allocations? No draft order or email will be created.")) return;
      setLoading(true);
      try {
        const payload = await api("/makeup-operations/invoice-record", { method: "POST", body: JSON.stringify({
          inbox_id: state.activeInboxId, confirmation: "RECORD ARRIVAL",
          expected_review_fingerprint: state.lastInvoicePlan.review_fingerprint,
        }) });
        refs.form.elements.release_id.value = payload.release_id;
        state.selectedBatchId = payload.arrival_batch_id;
        await loadOperations(state.activeInboxId);
        await load();
        openBatchWorkspace(state.inbox.find((row) => row.inbox_id === state.activeInboxId), "payments");
        toast(payload.duplicate ? "This invoice was already recorded." : "Arrival recorded. Review allocations before preparing Shopify drafts.");
      } catch (error) {
        toast(`Arrival record failed: ${error.message}`);
      } finally { setLoading(false); }
      return;
    }
    const button = event.target.closest("[data-save-line-match]");
    if (!button || !state.activeInboxId) return;
    const article = button.closest("[data-inbox-line]");
    const code = article?.dataset.inboxLine || "";
    const value = article?.querySelector("[data-line-match]")?.value || "review";
    const [kind, release = ""] = value.split(":", 2);
    const matchSource = kind === "release" ? "operational_release" : kind;
    const reason = article?.querySelector("[data-line-reason]")?.value.trim() || "";
    if (matchSource === "inventory" && !reason) return toast("Add a reason before assigning this line to inventory.");
    setLoading(true);
    try {
      await api("/makeup-operations/supplier-line-match", { method: "POST", body: JSON.stringify({
        inbox_id: state.activeInboxId,
        variant_code: code,
        match_source: matchSource,
        release_id: release,
        reason,
      }) });
      state.lastInvoicePlan = null;
      const payload = await loadOperations(state.activeInboxId);
      const row = state.inbox.find((item) => item.inbox_id === state.activeInboxId);
      renderInboxDetail(row, payload?.selected_inbox_lines || []);
      toast(`${code} match saved.`);
    } catch (error) {
      toast(`Unable to save line match: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.customerAllocations?.addEventListener("submit", async (event) => {
    const form = event.target.closest("[data-confirm-legacy-recipient]");
    if (!form) return;
    event.preventDefault();
    if (!state.activeInboxId || !state.lastInvoicePlan) return toast("Preview this invoice before confirming a recipient.");
    const code = form.dataset.code;
    const email = form.elements.recipient_email.value.trim();
    if (!form.elements.verified.checked) return toast(`Verify the original order for ${code} before saving.`);
    setLoading(true);
    try {
      await api("/makeup-operations/legacy-recipient-confirm", { method: "POST", body: JSON.stringify({
        commitment_id: form.dataset.commitmentId,
        variant_code: code,
        recipient_email: email,
        request_id: `recipient-${Date.now()}-${crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2)}`,
        confirmation: "CONFIRM LEGACY RECIPIENT",
      }) });
      const payload = await api("/makeup-operations/invoice-preview", { method: "POST", body: JSON.stringify({ inbox_id: state.activeInboxId }) });
      state.lastInvoicePlan = payload.plan;
      renderInvoicePlan(payload.plan);
      const recordButton = refs.inboxDetail.querySelector("[data-record-invoice]");
      if (recordButton) {
        const source = state.inbox.find((row) => row.inbox_id === state.activeInboxId);
        recordButton.disabled = Boolean((payload.plan.blocking_issues || []).length || !source?.receipt_review?.arrived_at || source?.invoice_evidence_status !== "verified");
        recordButton.classList.toggle("kob-mac-button--primary", !recordButton.disabled);
      }
      toast(`Recipient saved for ${code}. Review the refreshed allocation before recording.`);
    } catch (error) {
      toast(`Recipient was not saved: ${error.message}`);
    } finally { setLoading(false); }
  });

  function renderInvoicePlan(plan) {
    if (refs.previewIssues) {
      refs.previewIssues.hidden = !(plan.blocking_issues || []).length;
      refs.previewIssues.textContent = (plan.blocking_issues || []).length
        ? `Before recording: ${plan.blocking_issues.join(" · ")}` : "";
    }
    const normalized = {
      is_invoice_plan: true,
      rows: (plan.rows || []).map((row) => ({
        ...row,
        customer_allocated_now_qty: row.customer_allocated_qty || row.customer_allocated_now_qty || 0,
        customer_waiting_qty: row.outstanding_after_qty || row.customer_waiting_qty || 0,
        partner_allocated_now_qty: row.partner_allocated_qty || row.partner_allocated_now_qty || 0,
        catalog_action: "prepare_product_release",
        catalog_inventory_qty: row.inventory_qty ?? (Number(row.inventory_allocated_qty || 0) + Number(row.available_remainder_qty || 0)),
      })),
      allocations: plan.allocations || [],
      adjustments: plan.adjustments || [],
      partner_adjustment_max_quantity: Number(plan.partner_adjustment_max_quantity || 3),
      totals: {
        arrived_qty: plan.totals?.arrived_qty || 0,
        customer_allocated_now_qty: plan.totals?.customer_allocated_qty || 0,
        partner_allocated_now_qty: plan.totals?.partner_allocated_qty || 0,
        available_remainder_qty: plan.totals?.inventory_qty ?? plan.totals?.available_remainder_qty ?? 0,
        customer_invoice_ready_count: plan.totals?.customer_balance_ready_count || 0,
        partner_invoice_ready_count: plan.totals?.partner_balance_ready_count || 0,
        points_to_award: (plan.allocations || []).reduce((sum, row) => sum + Number(row.points_to_award || 0), 0),
      },
    };
    renderPreview(normalized);
    setWorkflowStage(
      3,
      "Review and confirm the allocation",
      "Customer commitments are allocated first, followed by partner quantities and remaining inventory. Adjust only the items that need a business decision.",
      (plan.blocking_issues || []).length ? `${plan.blocking_issues.length} issue${plan.blocking_issues.length === 1 ? "" : "s"} must be resolved` : "Ready to confirm",
    );
  }

  async function load(preferredBatchId = "", { readOnly = false } = {}) {
    if (!releaseId() && !preferredBatchId) return toast("Enter a preorder release first.");
    setLoading(true);
    try {
      const query = new URLSearchParams();
      if (releaseId()) query.set("release_id", releaseId());
      if (preferredBatchId) query.set("arrival_batch_id", preferredBatchId);
      const payload = await api(`/makeup-arrivals/admin.json?${query.toString()}`);
      if (refs.form?.elements?.release_id) refs.form.elements.release_id.value = payload.release_id || releaseId();
      state.supplierRows = payload.supplier_rows || [];
      state.recordedLines = payload.lines || [];
      state.allocations = payload.allocations || [];
      state.directPurchases = payload.direct_purchases || [];
      state.productPreviews = payload.product_previews || {};
      state.batches = payload.batches || [];
      state.selectedBatchId = payload.selected_arrival_batch_id || "";
      state.draftWritesEnabled = payload.draft_writes_enabled === true;
      state.invoiceSendingEnabled = payload.invoice_sending_enabled === true;
      state.draftPlanStale = payload.draft_plan_stale === true;
      state.draftPlanRefreshBlocked = payload.draft_plan_refresh_blocked === true;
      state.lastPlan = null;
      state.paymentReadFailed = false;
      state.lastDraftPlan = { groups: payload.draft_groups || [] };
      state.selectedGroupIds = new Set(
        (payload.draft_groups || [])
          .filter((row) => ["prepared", "ready", "draft_created"].includes(row.status))
          .map((row) => row.group_id),
      );
      state.requestId = "";
      renderInputRows();
      renderHistory();
      renderCatalog();
      renderDirectPurchases();
      renderDraftGroups(payload.draft_groups || []);
      clearPreview();
      if (state.selectedBatchId) renderRecordedAllocationReview(payload);
      hydrateProductPreviews([
        ...state.supplierRows.map((row) => row.variant_code),
        ...state.recordedLines.map((row) => row.variant_code),
      ]);
      refs.releaseTitle.textContent = payload.release_id;
      refs.status.textContent = state.selectedBatchId ? "Recorded arrival restored" : "Live preorder data";
      refs.preview.disabled = !state.supplierRows.length;
      refs.draftStatus.textContent = state.selectedBatchId ? "Recorded state restored" : "Waiting for arrival confirmation";
      updateWorkflowUI();
      if (!readOnly && state.draftPlanStale && !state.draftPlanRefreshBlocked && !state.autoRefreshingDraftPlan) {
        state.autoRefreshingDraftPlan = true;
        await prepareDrafts({ silent: true });
        state.autoRefreshingDraftPlan = false;
      }
      return payload;
    } catch (error) {
      state.paymentReadFailed = true;
      state.invoiceSendingEnabled = null;
      toast(`Unable to load release: ${error.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  }

  function catalogProductURL(line) {
    const origin = location.origin === 'null' ? 'https://kind-of-blu.com' : location.origin;
    const base = new URL(root.dataset.productControlUrl || '/pages/kob-product-release-control', origin);
    if (base.origin !== origin || !/^\/(?:zh\/|ja\/)?pages\/kob-product-release-control$/.test(base.pathname)) throw new Error('Unexpected Product Releases destination');
    const prefix = location.pathname.match(/^\/(zh|ja)(?:\/|$)/)?.[1];
    base.pathname = (prefix ? '/' + prefix : '') + '/pages/kob-product-release-control';
    const linked = line.product_release_batch_id && line.product_release_item_id;
    if (linked) { base.searchParams.set('batch_id', line.product_release_batch_id); base.searchParams.set('item_id', line.product_release_item_id); }
    else if (line.arrival_line_id) base.searchParams.set('catalog_line', line.arrival_line_id);
    const context = new URL(location.href).searchParams, campaign = context.get('sales_campaign');
    if (/^sc_[0-9a-f-]{36}$/i.test(campaign || '')) {
      base.searchParams.set('sales_campaign', campaign);
      base.searchParams.set('sales_kind', context.get('sales_kind') === 'discovery' ? 'discovery' : 'ordinary');
      base.searchParams.set('sales_source', 'surplus');
    }
    return base.pathname + base.search;
  }
  function renderCatalog() {
    if (!refs.catalog) return;
    if (!state.recordedLines.length) {
      refs.catalog.innerHTML = "<p>Record an arrival to prepare catalog product drafts.</p>";
      return;
    }
    refs.catalog.innerHTML = state.recordedLines.map((line) => {
      const product = state.supplierRows.find((row) => row.variant_code === line.variant_code) || {};
      const linked = line.product_release_batch_id && line.product_release_item_id;
      const claimed = Boolean(line.catalog_claim_key);
      const inventoryChanged = claimed && Number(line.catalog_inventory_snapshot) !== Number(line.catalog_inventory_qty);
      const productControlUrl = catalogProductURL(line);
      return `<article data-catalog-code="${escapeHtml(line.variant_code)}" data-catalog-line-id="${escapeHtml(line.arrival_line_id || "")}"${state.catalogLineId === line.arrival_line_id ? ' class="is-linked-target"' : ""}>
        <div><strong>${escapeHtml(line.variant_code)} / ${escapeHtml(productDetails(line.variant_code, product.product_title || line.product_title || "").title)}</strong><span>Catalog ${escapeHtml(line.handoff_state || line.catalog_status)} · originals ${escapeHtml(line.photo_status)}</span><small>Prepare physical originals and the product handoff in Product Releases. Shopify's total stock is reviewed there.</small>${inventoryChanged ? `<small>Quantity changed since the claim (${number(line.catalog_inventory_snapshot)}).</small>` : ""}</div>
        <div><span>Arrived</span><strong>${number(line.arrived_qty)}</strong></div>
        <div><span>This arrival's unallocated quantity</span><strong>${number(line.catalog_inventory_qty)}</strong></div>
        <div style="grid-column:1/-1;display:flex;flex-wrap:wrap;gap:.6rem;align-items:center">
          ${linked ? `<a class="kob-mac-button" href="${escapeHtml(productControlUrl)}">Open linked product</a>` : `<a class="kob-mac-button" href="${escapeHtml(productControlUrl)}">${claimed ? "Resume in Product Releases" : "Prepare in Product Releases"}</a>`}
        </div>
      </article>`;
    }).join("");
  }

  function showCatalogLinkStatus(message) {
    if (!refs.catalogLinkStatus || !refs.catalogLinkBanner) return;
    refs.catalogLinkStatus.textContent = message;
    refs.catalogLinkBanner.hidden = !message;
  }

  async function openCatalogLine(lineId) {
    root.dataset.view = "batch";
    selectBatchTab("remainder", { allowUnrecorded: true });
    if (refs.batchTitle) refs.batchTitle.textContent = "Catalog handoff";
    if (!/^[A-Za-z0-9:_-]{1,160}$/.test(lineId)) {
      showCatalogLinkStatus("This catalog line link is invalid. Open a recorded arrival to review its catalog products.");
      return;
    }
    showCatalogLinkStatus("Finding the recorded arrival line...");
    try {
      let candidate = null;
      let offset = 0;
      while (true) {
        const payload = await catalogApi(`/makeup-arrivals/catalog-candidates.json?limit=200&offset=${offset}`);
        candidate = (payload.candidates || []).find((row) => row.arrival_line_id === lineId) || null;
        if (candidate) break;
        const nextOffset = payload.next_offset;
        if (!Number.isSafeInteger(nextOffset) || nextOffset <= offset || nextOffset > 10000) break;
        offset = nextOffset;
      }
      if (!candidate?.arrival_batch_id) {
        showCatalogLinkStatus("The linked catalog line was not found among recorded arrivals. Check the line ID in Product Releases.");
        return;
      }
      state.catalogLineId = lineId;
      const payload = await load(candidate.arrival_batch_id, { readOnly: true });
      selectBatchTab("remainder", { allowUnrecorded: true });
      if (refs.batchTitle) refs.batchTitle.textContent = `${candidate.variant_code || "Model"} arrival`;
      const line = payload?.selected_arrival_batch_id === candidate.arrival_batch_id
        ? state.recordedLines.find((row) => row.arrival_line_id === lineId) : null;
      const article = [...(refs.catalog?.querySelectorAll("[data-catalog-line-id]") || [])]
        .find((row) => row.dataset.catalogLineId === lineId);
      if (!line || !article) {
        state.catalogLineId = "";
        showCatalogLinkStatus("The linked catalog line could not be opened in its recorded arrival. Refresh Product Releases and try again.");
        return;
      }
      showCatalogLinkStatus(`${line.variant_code} arrival line selected. Review its photo status and catalog handoff controls below.`);
      article.tabIndex = -1;
      article.focus({ preventScroll: true });
      article.scrollIntoView({ behavior: "smooth", block: "center" });
    } catch {
      state.catalogLineId = "";
      showCatalogLinkStatus("The linked catalog line could not be loaded. Refresh the page or open a recorded arrival manually.");
    }
  }

  function renderDirectPurchases() {
    if (!refs.directInventory || !refs.directRequests) return;
    if (refs.directNote) refs.directNote.textContent = state.selectedBatchId
      ? "Reserve remaining unlisted units after customer and partner allocation. The reservation reduces the remainder immediately. Go to Payments to review and create the payment link, then send the email separately."
      : "Confirm the arrival and its customer and partner allocations first. Direct purchase will then be available here for any remaining unlisted units. No payment link or email is created by confirming the arrival.";
    if (!state.selectedBatchId || !state.recordedLines.length) {
      if (refs.directForm) refs.directForm.hidden = true;
      refs.directInventory.innerHTML = "<p>Available after arrival confirmation.</p>";
      refs.directRequests.innerHTML = "<p>No direct customer purchases in this arrival.</p>";
      if (refs.directStatus) refs.directStatus.textContent = "Waiting for a recorded arrival";
      return;
    }
    const activeStatuses = new Set(["reserved", "prepared", "draft_created", "invoice_sent"]);
    refs.directInventory.innerHTML = state.recordedLines.map((line) => {
      const available = Number(line.catalog_inventory_qty || 0);
      const pending = state.directPurchases
        .filter((row) => row.variant_code === line.variant_code && activeStatuses.has(row.status))
        .reduce((sum, row) => sum + Number(row.quantity || 0), 0);
      const completed = state.directPurchases
        .filter((row) => row.variant_code === line.variant_code && row.status === "completed")
        .reduce((sum, row) => sum + Number(row.quantity || 0), 0);
      const catalogLinked = Boolean(line.catalog_claim_key || line.product_release_item_id);
      const officialPrice = Number(line.official_unit_price_jpy || 0);
      const disabled = available <= 0 || catalogLinked || officialPrice <= 0;
      const reason = catalogLinked
        ? "Catalog handoff started"
        : officialPrice <= 0
          ? "Miyazawa official price unavailable"
          : available > 0 ? `${number(available)} available before listing` : "No unallocated quantity";
      return `<article class="kob-mac__direct-sku" data-direct-code="${escapeHtml(line.variant_code)}">
        <div>${renderModelCode(line.variant_code, line.product_title || "")}<span>${escapeHtml(reason)} · Miyazawa official JPY ${number(officialPrice)} · ${number(pending)} awaiting payment · ${number(completed)} paid</span></div>
        <button class="kob-mac-button" type="button" data-direct-start data-code="${escapeHtml(line.variant_code)}" data-available="${available}" data-official-price="${officialPrice}"${disabled ? " disabled" : ""}>Direct purchase</button>
      </article>`;
    }).join("");
    refs.directRequests.innerHTML = state.directPurchases.length ? state.directPurchases.map((row) => {
      const cancellable = !["completed", "cancelled"].includes(row.status);
      const priceEditable = ["reserved", "prepared", "review"].includes(row.status)
        && !row.shopify_draft_order_id && !row.invoice_sent_at;
      const officialPrice = Number(row.official_unit_price_jpy || 0);
      const salePrice = Number(row.sale_unit_price_jpy || 0);
      const adjusted = officialPrice > 0 && salePrice > 0 && officialPrice !== salePrice;
      const statusLabel = {
        reserved: "Reserved",
        prepared: "Ready for payment review",
        draft_created: "Payment link created",
        invoice_sent: "Awaiting payment",
        review: "Payment needs review",
        completed: "Paid",
        cancelled: "Cancelled / released",
      }[row.status] || row.status;
      const effectiveStatus = Number(row.price_review_required || 0) === 1 ? "Price confirmation required" : statusLabel;
      const paymentNote = ["reserved", "prepared"].includes(row.status)
        ? "No payment link created. No email sent."
        : row.status === "draft_created" ? "Payment link created. No email sent."
          : "";
      return `<article class="kob-mac__direct-request" data-direct-request="${escapeHtml(row.request_id)}">
        <div><strong>${escapeHtml(row.customer_email)}</strong><span>${escapeHtml(row.variant_code)} · ${escapeHtml(row.product_title || "")}</span></div>
        <div><span>Quantity</span><strong>${number(row.quantity)}</strong></div>
        <div><span>Miyazawa official</span><strong>JPY ${number(officialPrice)}</strong></div>
        <div><span>Sale unit price${adjusted ? " · adjusted" : ""}</span><strong>JPY ${number(salePrice)}</strong></div>
        <div><span>Payment</span><strong>JPY ${number(row.subtotal_jpy)}</strong></div>
        <div><span>Points</span><strong>${number(row.points_to_award)}</strong></div>
        <div><em>${escapeHtml(effectiveStatus)}</em>${paymentNote ? `<span>${paymentNote}</span>` : ""}</div>
        ${priceEditable ? `<details class="kob-mac__direct-price-editor">
          <summary>Adjust sale price</summary>
          <label><span>Sale unit price (JPY)</span><input data-direct-price-value type="number" inputmode="numeric" min="1" step="1" value="${salePrice || officialPrice}"></label>
          <label><span>Reason when different from official</span><input data-direct-price-reason type="text" maxlength="1000" value="${escapeHtml(row.price_override_reason || "")}"></label>
          <button class="kob-mac-button" type="button" data-direct-reprice>Review updated price</button>
        </details>` : ""}
        <div class="kob-mac__actions kob-mac__direct-actions">
          ${row.status !== "cancelled" ? '<button class="kob-mac-button" type="button" data-direct-payments>Go to Payments</button>' : ""}
          ${row.invoice_url ? `<a class="kob-mac-button" href="${escapeHtml(row.invoice_url)}" target="_blank" rel="noopener">Open link</a>` : ""}
          ${cancellable ? `<button class="kob-mac-button" type="button" data-direct-cancel>Cancel & release</button>` : ""}
        </div>
      </article>`;
    }).join("") : "<p>No direct customer purchases in this arrival.</p>";
    const activeCount = state.directPurchases.filter((row) => activeStatuses.has(row.status)).length;
    if (refs.directStatus) refs.directStatus.textContent = activeCount ? `${activeCount} active direct purchase${activeCount === 1 ? "" : "s"}` : "No active direct purchases";
  }

  function resetDirectPurchasePreview() {
    state.directPurchasePreview = null;
    state.directReservationRequestId = "";
    if (refs.directPreview) {
      refs.directPreview.hidden = true;
      refs.directPreview.innerHTML = "";
    }
    if (refs.directReserve) refs.directReserve.disabled = true;
  }

  refs.directInventory?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-direct-start]");
    if (!button || !refs.directForm) return;
    const code = button.dataset.code || "";
    const available = Number(button.dataset.available || 0);
    const officialPrice = Number(button.dataset.officialPrice || 0);
    const line = state.recordedLines.find((row) => row.variant_code === code) || {};
    refs.directForm.hidden = false;
    refs.directForm.elements.variant_code.value = code;
    refs.directForm.elements.quantity.value = "1";
    refs.directForm.elements.quantity.max = String(available);
    refs.directForm.elements.customer_email.value = "";
    refs.directForm.elements.sale_unit_price_jpy.value = officialPrice > 0 ? String(officialPrice) : "";
    refs.directForm.elements.price_override_reason.value = "";
    refs.directForm.elements.note.value = "";
    if (refs.directSelected) refs.directSelected.textContent = `${code} · ${line.product_title || "Unlisted Make Up arrival"} · ${number(available)} available · Miyazawa official JPY ${number(officialPrice)}`;
    resetDirectPurchasePreview();
    refs.directForm.scrollIntoView({ behavior: "smooth", block: "center" });
  });

  refs.directForm?.addEventListener("input", resetDirectPurchasePreview);
  refs.directForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!state.selectedBatchId) return;
    const form = new FormData(refs.directForm);
    setLoading(true);
    try {
      const payload = await api("/makeup-arrivals/direct-purchase-preview", {
        method: "POST",
        body: JSON.stringify({
          arrival_batch_id: state.selectedBatchId,
          variant_code: form.get("variant_code"),
          customer_email: form.get("customer_email"),
          quantity: Number(form.get("quantity") || 0),
          sale_unit_price_jpy: Number(form.get("sale_unit_price_jpy") || 0),
          price_override_reason: String(form.get("price_override_reason") || "").trim(),
        }),
      });
      state.directPurchasePreview = payload.direct_purchase;
      state.directReservationRequestId = `MAKEUP_DIRECT:${crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`}`;
      const preview = payload.direct_purchase;
      refs.directPreview.hidden = false;
      refs.directPreview.innerHTML = `
        <div><span>Shopify customer</span><strong>${escapeHtml(preview.customer_email)}</strong></div>
        <div><span>Miyazawa official unit price</span><strong>JPY ${number(preview.official_unit_price_jpy)}</strong></div>
        <div><span>Sale unit price${preview.price_adjusted ? " · adjusted" : ""}</span><strong>JPY ${number(preview.sale_unit_price_jpy)}</strong></div>
        <div><span>Payment</span><strong>JPY ${number(preview.subtotal_jpy)}</strong></div>
        <div><span>Points after payment</span><strong>${number(preview.points_to_award)}</strong></div>
        <div><span>Remainder after reserve</span><strong>${number(preview.available_after_qty)}</strong></div>`;
      refs.directReserve.disabled = false;
      toast("Direct purchase preview is ready. No inventory, payment link or email was changed.");
    } catch (error) {
      resetDirectPurchasePreview();
      toast(`Direct purchase preview failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.directReserve?.addEventListener("click", async () => {
    const preview = state.directPurchasePreview;
    if (!preview || !state.directReservationRequestId) return;
    if (!window.confirm(`Reserve ${preview.quantity} × ${preview.variant_code} for ${preview.customer_email} at JPY ${number(preview.sale_unit_price_jpy)} each? Miyazawa official is JPY ${number(preview.official_unit_price_jpy)}. The catalog remainder will change from ${preview.available_before_qty} to ${preview.available_after_qty}.`)) return;
    setLoading(true);
    try {
      const note = String(refs.directForm?.elements?.note?.value || "").trim();
      const payload = await api("/makeup-arrivals/direct-purchase-reserve", {
        method: "POST",
        body: JSON.stringify({
          request_id: state.directReservationRequestId,
          arrival_batch_id: state.selectedBatchId,
          variant_code: preview.variant_code,
          customer_email: preview.customer_email,
          quantity: preview.quantity,
          sale_unit_price_jpy: preview.sale_unit_price_jpy,
          price_override_reason: preview.price_override_reason,
          note,
          confirmation: "RESERVE DIRECT PURCHASE",
        }),
      });
      const requestId = payload.direct_purchase?.request_id || state.directReservationRequestId;
      const batchId = state.selectedBatchId;
      if (refs.directForm) refs.directForm.hidden = true;
      resetDirectPurchasePreview();
      await load(batchId);
      const directGroups = (state.lastDraftPlan?.groups || []).filter((row) => (
        row.payment_purpose === "direct_purchase" && row.source_group_key === requestId
      ));
      state.selectedGroupIds = new Set(directGroups.map((row) => row.group_id));
      renderDraftGroups(state.lastDraftPlan?.groups || []);
      updateWorkflowUI();
      selectBatchTab("allocation");
      refs.directRequests?.scrollIntoView({ behavior: "smooth", block: "start" });
      toast("Inventory reserved. No payment link or email was created. Choose Go to Payments on this request to continue.");
    } catch (error) {
      toast(`Direct purchase reservation failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  refs.directRequests?.addEventListener("click", async (event) => {
    const paymentsButton = event.target.closest("[data-direct-payments]");
    if (paymentsButton) {
      if (state.loading || !state.selectedBatchId) return;
      const requestId = paymentsButton.closest("[data-direct-request]")?.dataset.directRequest;
      const groups = state.lastDraftPlan?.groups || [];
      const directGroups = groups.filter((row) => (
        row.payment_purpose === "direct_purchase" && row.source_group_key === requestId
      ));
      state.selectedGroupIds = new Set(directGroups
        .filter((row) => ["ready", "prepared", "draft_created"].includes(row.status))
        .map((row) => row.group_id));
      renderDraftGroups(groups);
      updateWorkflowUI();
      selectBatchTab("payments");
      const card = Array.from(refs.draftGroups?.querySelectorAll("[data-draft-group]") || [])
        .find((element) => directGroups.some((row) => row.group_id === element.dataset.draftGroup));
      (card || refs.draftStatus)?.scrollIntoView({ behavior: "smooth", block: "start" });
      toast(directGroups.length
        ? "Opened this direct purchase in Payments. Creating its link and sending its email remain separate actions."
        : "Review payment requests to prepare this direct purchase. No payment link or email was created.");
      return;
    }
    const repriceButton = event.target.closest("[data-direct-reprice]");
    if (repriceButton) {
      const article = repriceButton.closest("[data-direct-request]");
      const requestId = article?.dataset.directRequest || "";
      const row = state.directPurchases.find((item) => item.request_id === requestId) || {};
      const saleUnitPrice = Number(article?.querySelector("[data-direct-price-value]")?.value || 0);
      const reason = String(article?.querySelector("[data-direct-price-reason]")?.value || "").trim();
      if (saleUnitPrice <= 0) return toast("Enter a valid JPY sale unit price.");
      if (saleUnitPrice !== Number(row.official_unit_price_jpy || 0) && !reason) {
        return toast("Explain why the sale price differs from the Miyazawa official price.");
      }
      if (!window.confirm(`Update this direct purchase to JPY ${number(saleUnitPrice)} per unit? The Miyazawa official price remains JPY ${number(row.official_unit_price_jpy)}. No Shopify payment link or email will be created.`)) return;
      setLoading(true);
      try {
        await api("/makeup-arrivals/direct-purchase-reprice", {
          method: "POST",
          body: JSON.stringify({
            request_id: requestId,
            sale_unit_price_jpy: saleUnitPrice,
            price_override_reason: reason,
            confirmation: "UPDATE DIRECT PURCHASE PRICE",
          }),
        });
        await load(state.selectedBatchId);
        toast("Direct purchase price reviewed. Its payment card was rebuilt; no Shopify payment link or email was created.");
      } catch (error) {
        toast(`Direct purchase price update failed: ${error.message}`);
      } finally { setLoading(false); }
      return;
    }

    const button = event.target.closest("[data-direct-cancel]");
    const article = button?.closest("[data-direct-request]");
    if (!button || !article) return;
    const requestId = article.dataset.directRequest || "";
    const reason = window.prompt("Internal reason for cancelling and releasing this quantity:", "Customer no longer proceeding.");
    if (!reason?.trim()) return;
    if (!window.confirm("Cancel this direct purchase and release its reserved quantity? An existing unpaid Shopify Draft Order will be deleted.")) return;
    setLoading(true);
    try {
      await api("/makeup-arrivals/direct-purchase-cancel", {
        method: "POST",
        body: JSON.stringify({ request_id: requestId, reason: reason.trim(), confirmation: "CANCEL DIRECT PURCHASE" }),
      });
      await load(state.selectedBatchId);
      toast("Direct purchase cancelled. Its quantity is available for catalog listing again.");
    } catch (error) {
      toast(`Direct purchase cancellation failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  function renderInputRows() {
    if (!state.supplierRows.length) {
      refs.inputRows.innerHTML = '<tr><td colspan="7">No products found for this release.</td></tr>';
      return;
    }
    refs.inputRows.innerHTML = state.supplierRows.map((row) => `<tr data-code="${escapeHtml(row.variant_code)}">
      <td data-label="Model"><strong>${escapeHtml(row.variant_code)}</strong><small>${escapeHtml(row.product_title || "")}</small></td>
      <td data-label="Customer">${number(row.customer_preorder_qty)}</td>
      <td data-label="Partner">${number(row.partner_requested_qty)}</td>
      <td data-label="Supplier">${number(row.supplier_ordered_qty)}</td>
      <td data-label="Arrived"><input data-arrived type="number" inputmode="numeric" min="0" step="1" value="0" aria-label="${escapeHtml(row.variant_code)} arrived quantity"></td>
      <td data-label="Supplier cost"><input data-partner-cost type="number" inputmode="numeric" min="0" step="1" value="0" aria-label="${escapeHtml(row.variant_code)} tax-inclusive supplier unit cost"></td>
      <td data-label="Catalog route"><select data-photo aria-label="${escapeHtml(row.variant_code)} catalog route"><option value="missing">Prepare in Product Releases</option><option value="not_required">No catalog record</option></select></td>
    </tr>`).join("");
  }

  function inputLines() {
    return Array.from(refs.inputRows.querySelectorAll("tr[data-code]")).map((row) => ({
      variant_code: row.dataset.code,
      arrived_qty: Math.max(Number.parseInt(row.querySelector("[data-arrived]")?.value || "0", 10) || 0, 0),
      partner_cost_unit_jpy: Math.max(Number.parseInt(row.querySelector("[data-partner-cost]")?.value || "0", 10) || 0, 0),
      photo_status: row.querySelector("[data-photo]")?.value || "missing",
    })).filter((row) => row.arrived_qty > 0);
  }

  async function preview() {
    const lines = inputLines();
    if (!lines.length) return toast("Enter at least one arrived quantity.");
    setLoading(true);
    try {
      const payload = await api("/makeup-arrivals/preview", { method: "POST", body: JSON.stringify({ release_id: releaseId(), lines }) });
      state.lastPlan = payload.plan;
      if (!state.requestId) state.requestId = `arrival-${Date.now()}-${crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2)}`;
      renderPreview(payload.plan);
      refs.record.disabled = false;
      toast("Allocation preview updated. No invoices were sent.");
    } catch (error) {
      toast(`Preview failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  function renderPreview(plan) {
    state.allocations = plan.allocations || [];
    root.dataset.hasSummary = "true";
    refs.previewPanel.hidden = false;
    refs.previewRows.innerHTML = (plan.rows || []).map((row) => `<tr>
      <td data-label="Code">${renderModelCode(row.variant_code)}</td>
      <td data-label="Arrived">${number(row.arrived_qty)}${plan.is_invoice_plan ? `<small>Shanghai ${number(row.shanghai_qty)} · Ariake ${number(row.ariake_qty)}${Number(row.invoice_qty) !== Number(row.arrived_qty) ? ` · invoiced ${number(row.invoice_qty)}` : ""}</small>` : ""}</td>
      <td data-label="Customer">${number(row.customer_allocated_now_qty)}${Number(row.customer_waiting_qty || 0) ? `<small>${number(row.customer_waiting_qty)} waiting</small>` : ""}</td>
      <td data-label="Partner">${number(row.partner_allocated_now_qty)}</td>
      <td data-label="Remainder">${number(row.catalog_inventory_qty ?? row.available_remainder_qty)}</td>
      <td data-label="Partner adjustment">${renderPartnerAdjustmentControls(row, plan)}</td>
    </tr>`).join("");
    renderAllocationCards(plan.allocations || []);
    Object.entries(plan.totals || {}).forEach(([key, value]) => {
      const element = root.querySelector(`[data-kob-mac-total="${key}"]`);
      if (element) element.textContent = number(value);
    });
  }

  function allocationKind(row) {
    return row.kind || row.allocation_kind || "";
  }

  function allocationSourceLabel(row) {
    const source = row.payload?.source_type || "";
    if (source === "owner_post_arrival_reservation") {
      return Number(row.deposit_total_jpy || 0) > 0 ? "Owner reservation" : "Owner reservation / no deposit";
    }
    if (source === "owner_partner_adjustment") return "Owner partner adjustment";
    if (source === "legacy_xlsx") return "Legacy preorder";
    if (source === "shopify_order") return "Shopify preorder";
    return source ? source.replace(/_/g, " ") : "";
  }

  function customerDisplayName(email, row = null) {
    const normalizedEmail = String(email || "").trim().toLowerCase();
    const candidates = [
      row?.payload?.customer_key,
      ...state.allocations
        .filter((item) => String(item.recipient_email || "").trim().toLowerCase() === normalizedEmail)
        .map((item) => item.payload?.customer_key),
    ].map((value) => String(value || "").trim()).filter(Boolean);
    const preferred = candidates.find((value) => !value.includes("@") && !/^#?\d+$/.test(value));
    if (preferred) return preferred;
    return normalizedEmail ? normalizedEmail.split("@")[0] : "Customer";
  }

  function partnerDisplayName(value) {
    const key = String(value || "").trim().toLowerCase();
    if (key === "kob1003" || key === "kai") return "Kai";
    if (key === "azzurr0" || key === "dai") return "Dai";
    return value || "Partner";
  }

  function productDetails(code, fallbackTitle = "", fallbackDetail = "") {
    const key = String(code || "").trim().toUpperCase();
    const preview = receiptReference(key);
    const allocation = state.allocations.find((row) => String(row.variant_code || "").trim().toUpperCase() === key) || {};
    const supplier = state.supplierRows.find((row) => String(row.variant_code || "").trim().toUpperCase() === key) || {};
    const recorded = state.recordedLines.find((row) => String(row.variant_code || "").trim().toUpperCase() === key) || {};
    return {
      title: preview.title || recorded.product_title || fallbackTitle || allocation.payload?.product_title || supplier.product_title || "Product details unavailable",
      detail: preview.detail || fallbackDetail || allocation.payload?.product_detail || supplier.product_detail || "",
      imageUrl: preview.image_url || "",
    };
  }

  function renderModelCode(code, fallbackTitle = "", fallbackDetail = "") {
    const details = productDetails(code, fallbackTitle, fallbackDetail);
    return `<button class="kob-mac__model-code" type="button" data-model-code="${escapeHtml(code)}" data-model-title="${escapeHtml(fallbackTitle)}" data-model-detail="${escapeHtml(fallbackDetail)}">
      ${escapeHtml(code)}
      <span class="kob-mac__model-preview${details.imageUrl ? "" : " kob-mac__model-preview--text"}">
        ${details.imageUrl ? `<img src="${escapeHtml(details.imageUrl)}" alt="" loading="lazy">` : ""}
        <span><strong>${escapeHtml(details.title)}</strong>${details.detail ? `<span>${escapeHtml(details.detail)}</span>` : ""}</span>
      </span>
    </button>`;
  }

  function positionModelPreview(button) {
    const preview = button?.querySelector(".kob-mac__model-preview");
    if (!preview) return;
    // The allocation table scrolls horizontally. A fixed preview escapes its
    // clipping box and can be placed above the final row when space is tight.
    preview.style.display = "grid";
    preview.style.visibility = "hidden";
    const anchor = button.getBoundingClientRect();
    const width = preview.getBoundingClientRect().width;
    const height = preview.getBoundingClientRect().height;
    preview.style.display = "";
    preview.style.visibility = "";
    const gap = 8;
    const edge = 12;
    const below = anchor.bottom + gap;
    const top = below + height <= window.innerHeight - edge
      ? below : Math.max(edge, anchor.top - height - gap);
    preview.style.setProperty("--kob-preview-top", `${top}px`);
    preview.style.setProperty("--kob-preview-left", `${Math.max(edge, Math.min(anchor.left, window.innerWidth - width - edge))}px`);
  }

  function receiptReference(code) {
    const key = String(code || "").trim().toUpperCase();
    const publicPreview = state.productPreviews[key] || {};
    const inboxPreview = state.inboxProductPreviews[key] || {};
    return { ...publicPreview, ...inboxPreview, image_url: inboxPreview.image_url || publicPreview.image_url || "" };
  }

  function referenceNote(reference) {
    if (reference?.source === "preorder_source" && reference.image_url) return "Supplier preorder reference · confirm the physical model";
    if (reference?.source === "preorder_product" && reference.image_url) return "Preorder product reference · confirm the physical model";
    return reference?.image_url ? "Shopify reference · confirm the physical model" : "Supplier description · confirm the physical model";
  }

  async function hydrateProductPreviews(codes) {
    if (!/^https?:$/.test(window.location.protocol)) return;
    const unique = [...new Set(codes.map((code) => String(code || "").trim().toUpperCase()).filter(Boolean))]
      .filter((code) => (state.inboxProductPreviews[code]?.private_preorder_release_id && !state.inboxProductPreviews[code]?.image_url)
        || (!state.inboxProductPreviews[code]?.image_url && !state.productPreviews[code]?.loaded));
    await Promise.all(unique.map(async (code) => {
      const privateRelease = state.inboxProductPreviews[code]?.private_preorder_release_id;
      if (privateRelease) {
        try {
          const url = new URL(authUrl("/makeup-preorder-operations/product-image"));
          url.searchParams.set("release_id", privateRelease);
          url.searchParams.set("variant_code", code);
          const response = await fetch(url, { cache: "no-store", referrerPolicy: "no-referrer" });
          if (response.ok && String(response.headers.get("content-type") || "").startsWith("image/")) {
            const blob = await response.blob();
            if (blob.size && state.inboxProductPreviews[code]?.private_preorder_release_id === privateRelease) {
              state.inboxProductPreviews[code] = { ...state.inboxProductPreviews[code], image_url: URL.createObjectURL(blob), object_url: true };
              return;
            }
          }
        } catch { /* Keep the placeholder when the private reference is unavailable. */ }
      }
      if (state.inboxProductPreviews[code]?.image_url) return;
      state.productPreviews[code] = { ...(state.productPreviews[code] || {}), loaded: true };
      try {
        const query = new URLSearchParams({
          q: code,
          "resources[type]": "product",
          "resources[limit]": "4",
        });
        const response = await fetch(`/search/suggest.json?${query.toString()}`, {
          headers: { accept: "application/json" },
        });
        if (!response.ok) return;
        const payload = await response.json();
        const products = payload?.resources?.results?.products || [];
        const exactCode = (value) => String(value || "").toUpperCase().split(/[^A-Z0-9]+/).includes(code);
        const product = products.find((item) => (item.variants || []).some((variant) => String(variant.sku || "").trim().toUpperCase() === code)
          || exactCode(item.title) || exactCode(item.handle));
        if (!product) return;
        const imageUrl = product.featured_image?.url || product.featured_image || product.image || "";
        state.productPreviews[code] = {
          loaded: true,
          title: product.title || "",
          image_url: typeof imageUrl === "string" ? imageUrl : imageUrl?.url || "",
        };
      } catch {
        // Product previews are optional; allocation review remains usable without them.
      }
    }));
    root.querySelectorAll("[data-model-code]").forEach((button) => {
      const code = button.dataset.modelCode || "";
      const details = productDetails(code, button.dataset.modelTitle, button.dataset.modelDetail);
      const preview = button.querySelector(".kob-mac__model-preview");
      if (!preview) return;
      preview.classList.toggle("kob-mac__model-preview--text", !details.imageUrl);
      preview.innerHTML = `${details.imageUrl ? `<img src="${escapeHtml(details.imageUrl)}" alt="" loading="lazy">` : ""}
        <span><strong>${escapeHtml(details.title)}</strong>${details.detail ? `<span>${escapeHtml(details.detail)}</span>` : ""}</span>`;
    });
    root.querySelectorAll("[data-receipt-model-code]").forEach((model) => {
      const reference = receiptReference(model.dataset.receiptModelCode || "");
      const figure = model.querySelector("figure");
      const title = model.querySelector("[data-receipt-model-title]");
      const note = model.querySelector("small");
      if (figure) figure.innerHTML = reference.image_url ? `<img src="${escapeHtml(reference.image_url)}" alt="" loading="lazy">` : "Exact reference image unavailable";
      if (title) title.textContent = reference.title || model.dataset.supplierTitle || "Supplier title pending";
      if (note) note.textContent = referenceNote(reference);
    });
  }

  function renderAllocationCards(allocations) {
    state.allocations = allocations;
    const customerRows = allocations.filter((row) => allocationKind(row) === "customer");
    const partnerRows = allocations.filter((row) => allocationKind(row) === "partner");
    if (refs.allocationSummary) {
      const customerQuantity = customerRows.reduce((sum, row) => sum + Number(row.quantity || 0), 0);
      const partnerQuantity = partnerRows.reduce((sum, row) => sum + Number(row.quantity || 0), 0);
      refs.allocationSummary.textContent = `${number(customerQuantity)} customer unit${customerQuantity === 1 ? "" : "s"} · ${number(partnerQuantity)} partner unit${partnerQuantity === 1 ? "" : "s"}`;
    }
    refs.customerAllocations.innerHTML = customerRows.map((row) => {
      const source = allocationSourceLabel(row);
      const email = row.recipient_email || "";
      const balance = row.charge_amount ?? row.balance_due_jpy;
      const needsRecipient = Boolean(state.lastInvoicePlan && state.activeInboxId
        && row.payload?.source_type === "legacy_xlsx" && row.source_id
        && (row.issues || []).includes("missing_customer_email"));
      return `<article class="kob-mac__allocation${row.pricing_status === "ready" ? "" : " kob-mac__allocation--review"}">
        <div class="kob-mac__allocation-head">
          <button class="kob-mac__identity-button" type="button" data-customer-details="${escapeHtml(email)}">${escapeHtml(customerDisplayName(email, row))}</button>
          ${renderModelCode(row.variant_code, row.payload?.product_title, row.payload?.product_detail)}
        </div>
        <span class="kob-mac__allocation-meta">${number(row.quantity)} × ${escapeHtml(row.charge_currency || "JPY")} ${number(balance)} · ${number(row.points_to_award)} points</span>
        ${source ? `<span>${escapeHtml(source)}</span>` : ""}
        ${(row.issues || []).length ? `<span>${escapeHtml(row.issues.join(", "))}</span>` : ""}
        ${needsRecipient ? `<form class="kob-mac__recipient-form" data-confirm-legacy-recipient data-commitment-id="${escapeHtml(row.source_id)}" data-code="${escapeHtml(row.variant_code)}">
          <p>Verify the original preorder for ${escapeHtml(row.variant_code)}. This nickname may have used different emails for other models.</p>
          <label>Confirmed recipient email <input type="email" name="recipient_email" autocomplete="off" required></label>
          <label class="kob-mac__recipient-check"><input type="checkbox" name="verified" required> I verified this recipient against the original order for this exact model.</label>
          <button class="kob-mac-button" type="submit">Save recipient for ${escapeHtml(row.variant_code)}</button>
        </form>` : ""}
      </article>`;
    }).join("") || "<p>No customer balance allocations in this arrival.</p>";
    refs.partnerAllocations.innerHTML = partnerRows.map((row) => `<article class="kob-mac__allocation${row.pricing_status === "ready" ? "" : " kob-mac__allocation--review"}">
      <div class="kob-mac__allocation-head">
        <strong>${escapeHtml(partnerDisplayName(row.group_key || "Partner"))}</strong>
        ${renderModelCode(row.variant_code, row.payload?.product_title, row.payload?.product_detail)}
      </div>
      <span class="kob-mac__allocation-meta">${number(row.quantity)} × JPY ${number(row.balance_due_jpy)}</span>
      ${(row.issues || []).length ? `<span>${escapeHtml(row.issues.join(", "))}</span>` : ""}
    </article>`).join("") || "<p>No partner balance allocations in this arrival.</p>";
  }

  function renderPartnerAdjustmentControls(row, plan) {
    if (!plan.is_invoice_plan || !state.activeInboxId) return "-";
    const inventory = Number(row.catalog_inventory_qty ?? row.inventory_qty ?? row.available_remainder_qty ?? 0);
    const maxQuantity = Number(plan.partner_adjustment_max_quantity || 3);
    const partners = [{ alias: "KOB1003", label: "Kai" }, { alias: "Azzurr0", label: "Dai" }];
    return `<div class="kob-mac__partner-adjust">${partners.map((partner) => {
      const activeAdjustment = (plan.adjustments || []).find((item) => (
        item.variant_code === row.variant_code && item.partner_alias === partner.alias
      ));
      const existingQuantity = (plan.allocations || []).filter((item) => (
        item.kind === "partner"
        && item.variant_code === row.variant_code
        && String(item.group_key || "").toLowerCase() === partner.alias.toLowerCase()
        && item.payload?.source_type !== "owner_partner_adjustment"
      )).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const adjustmentQuantity = Number(activeAdjustment?.quantity || 0);
      const totalQuantity = existingQuantity + adjustmentQuantity;
      const canDecrease = adjustmentQuantity > 0;
      const canIncrease = totalQuantity < maxQuantity && inventory > 0;
      return `<div class="kob-mac__adjust-card${adjustmentQuantity ? " is-active" : ""}">
        <div class="kob-mac__adjust-status"><span>${partner.label}</span><strong>${number(totalQuantity)}/${number(maxQuantity)}</strong></div>
        <div class="kob-mac__adjust-steps">
          <button type="button" data-partner-adjust data-code="${escapeHtml(row.variant_code)}" data-partner-alias="${escapeHtml(partner.alias)}" data-quantity="${Math.max(adjustmentQuantity - 1, 0)}" data-direction="decrease" aria-label="Decrease ${partner.label} allocation"${canDecrease ? "" : " disabled"}>-</button>
          <button type="button" data-partner-adjust data-code="${escapeHtml(row.variant_code)}" data-partner-alias="${escapeHtml(partner.alias)}" data-quantity="${adjustmentQuantity + 1}" data-direction="increase" aria-label="Increase ${partner.label} allocation"${canIncrease ? "" : " disabled"}>+</button>
        </div>
        <small>${existingQuantity ? `${number(existingQuantity)} recorded` : "No prior allocation"}${adjustmentQuantity ? ` · ${number(adjustmentQuantity)} added` : ""}</small>
      </div>`;
    }).join("")}</div>`;
  }

  refs.previewPanel?.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-partner-adjust]");
    if (!button || !state.activeInboxId) return;
    const code = button.dataset.code || "";
    const partnerAlias = button.dataset.partnerAlias || "";
    const quantity = Number(button.dataset.quantity || 0);
    const direction = button.dataset.direction || "";
    setLoading(true);
    try {
      const payload = await api("/makeup-operations/allocation-adjustment", {
        method: "POST",
        body: JSON.stringify({
          inbox_id: state.activeInboxId,
          variant_code: code,
          partner_alias: partnerAlias,
          quantity,
          note: quantity ? `Owner preview allocation: ${quantity}` : "Owner removed preview allocation",
        }),
      });
      state.lastInvoicePlan = payload.plan;
      renderInvoicePlan(payload.plan);
      const label = partnerAlias === "KOB1003" ? "Kai" : "Dai";
      toast(direction === "increase"
        ? `${code}: ${label} increased to ${quantity} preview unit${quantity === 1 ? "" : "s"}. Inventory updated.`
        : `${code}: ${label} preview allocation reduced to ${quantity}. Inventory restored.`);
    } catch (error) {
      toast(`Partner adjustment failed: ${error.message}`);
    } finally { setLoading(false); }
  });

  async function record() {
    if (!state.lastPlan) return;
    const sourceLabel = String(refs.form.elements.source_label.value || "").trim();
    if (!sourceLabel) return toast("Add an arrival reference before recording.");
    if (!window.confirm("Record this arrival and its allocation plan? No invoice will be sent.")) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-arrivals/record", { method: "POST", body: JSON.stringify({
        request_id: state.requestId,
        release_id: releaseId(),
        source_label: sourceLabel,
        arrived_at: refs.form.elements.arrived_at.value,
        supplier_inbox_id: state.activeInboxId,
        lines: inputLines(),
      }) });
      toast(payload.duplicate ? "This arrival was already recorded." : "Arrival recorded. No invoice was sent.");
      state.activeInboxId = "";
      await loadOperations();
      await load();
    } catch (error) {
      toast(`Record failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  async function prepareDrafts(options = {}) {
    const silent = options.silent === true;
    if (!state.selectedBatchId) return toast("Record an arrival before preparing balance drafts.");
    setLoading(true);
    try {
      const payload = await api("/makeup-arrivals/draft-plan", { method: "POST", body: JSON.stringify({ arrival_batch_id: state.selectedBatchId }) });
      state.lastDraftPlan = payload.plan;
      state.draftWritesEnabled = payload.draft_writes_enabled === true;
      state.invoiceSendingEnabled = payload.invoice_sending_enabled === true;
      state.draftPlanStale = false;
      state.draftPlanRefreshBlocked = false;
      state.selectedGroupIds = new Set(
        (payload.plan.groups || [])
          .filter((row) => ["ready", "prepared", "draft_created"].includes(row.status))
          .map((row) => row.group_id),
      );
      renderDraftGroups(payload.plan.groups || []);
      refs.draftStatus.textContent = "Payment review is current";
      updateWorkflowUI();
      if (!silent) toast("Payment review updated. No Shopify payment link was created and no email was sent.");
    } catch (error) {
      toast(`Draft plan failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  async function createDrafts() {
    if (!state.lastDraftPlan || !state.draftWritesEnabled) return;
    const selected = selectedGroupsWithStatus("prepared")
      .concat(selectedGroupsWithStatus("ready"));
    if (!selected.length) return toast("Select at least one reviewed payment request.");
    if (!window.confirm(`Create ${selected.length} selected Shopify payment link${selected.length === 1 ? "" : "s"}? No email will be sent.`)) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-arrivals/create-drafts", { method: "POST", body: JSON.stringify({
        arrival_batch_id: state.selectedBatchId,
        group_ids: selected.map((row) => row.group_id),
        confirmation: "CREATE DRAFTS",
      }) });
      toast(`Payment link creation completed: ${(payload.results || []).filter((row) => row.status === "draft_created").length} created. No email was sent.`);
      await load();
    } catch (error) {
      toast(`Draft creation failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  async function sendInvoices() {
    if (!state.selectedBatchId || !state.invoiceSendingEnabled) return;
    const groups = state.lastDraftPlan?.groups || [];
    const ready = groups.filter((row) => (
      state.selectedGroupIds.has(row.group_id) && row.status === "draft_created"
    ));
    if (!ready.length) return toast("No unsent Shopify draft orders are ready in this arrival.");
    if (!window.confirm(`Send ${ready.length} reviewed balance invoice email${ready.length === 1 ? "" : "s"}?`)) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-arrivals/send-invoices", {
        method: "POST",
        body: JSON.stringify({
          arrival_batch_id: state.selectedBatchId,
          group_ids: ready.map((row) => row.group_id),
          confirmation: "SEND INVOICES",
        }),
      });
      toast(`Invoice sending completed: ${(payload.results || []).filter((row) => row.status === "invoice_sent").length} sent.`);
      await load();
    } catch (error) {
      toast(`Invoice sending failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  function renderDraftGroups(groups) {
    const visibleGroups = groups.filter((row) => row.status !== "cancelled");
    refs.draftGroups.innerHTML = visibleGroups.length ? visibleGroups.map((row) => {
      const selectable = ["ready", "prepared", "draft_created"].includes(row.status);
      const selected = state.selectedGroupIds.has(row.group_id);
      const lines = mergeDraftLines(row.draft_order?.lineItems || []);
      const kind = row.kind || row.allocation_kind || "";
      const statusLabel = {
        ready: "Ready for review",
        prepared: "Ready for review",
        review: "Needs correction",
        draft_created: "Payment link created",
        invoice_sent: "Email sent",
        completed: "Paid",
      }[row.status] || row.status || "Prepared";
      const customerName = kind === "partner"
        ? partnerDisplayName(row.group_key)
        : customerDisplayName(row.recipient_email);
      const directPurchase = row.payment_purpose === "direct_purchase"
        || row.draft_order?.tags?.includes("kob-makeup-direct-sale");
      return `<article class="kob-mac__draft-group${row.status === "review" ? " kob-mac__allocation--review" : ""}" data-draft-group="${escapeHtml(row.group_id)}">
        <header>
          <label class="kob-mac__group-select">
            <input type="checkbox" data-group-select value="${escapeHtml(row.group_id)}" aria-label="Select ${escapeHtml(customerName)} payment request"${selected ? " checked" : ""}${selectable ? "" : " disabled"}>
          </label>
          <div class="kob-mac__draft-customer">
            ${kind === "partner"
              ? `<strong>${escapeHtml(customerName)}</strong>`
              : `<button class="kob-mac__identity-button" type="button" data-customer-details="${escapeHtml(row.recipient_email || "")}">${escapeHtml(customerName)}</button>`}
            <small>${escapeHtml(kind === "partner" ? "Partner payment" : (directPurchase ? "Direct purchase before listing" : "Customer balance"))}</small>
          </div>
          <em>${escapeHtml(statusLabel)}</em>
        </header>
        <div class="kob-mac__draft-lines">
          ${lines.map((line) => {
            const parsed = parseDraftLineTitle(line.title);
            return `<div><span>${renderModelCode(parsed.code, parsed.title)}</span><strong>${number(line.quantity)} × ${escapeHtml(line.originalUnitPriceWithCurrency?.currencyCode || row.currency || "JPY")} ${number(line.originalUnitPriceWithCurrency?.amount || 0)}</strong></div>`;
          }).join("") || `<p>${number(row.line_count)} line${Number(row.line_count) === 1 ? "" : "s"} / quantity ${number(row.quantity)}</p>`}
        </div>
        <div class="kob-mac__draft-summary">
          <div><span>Balance</span><strong>${escapeHtml(row.currency || "JPY")} ${number(row.subtotal_amount ?? row.subtotal_jpy)}</strong></div>
          <div><span>Points after payment</span><strong>${kind === "partner" ? "None" : number(row.points_to_award)}</strong></div>
        </div>
        <details class="kob-mac__email-preview">
          <summary>Payment email summary</summary>
          <p>Shopify standard invoice email to <strong>${escapeHtml(row.recipient_email || "")}</strong>.</p>
          <p>${number(row.quantity)} item${Number(row.quantity) === 1 ? "" : "s"} · ${escapeHtml(row.currency || "JPY")} ${number(row.subtotal_amount ?? row.subtotal_jpy)}</p>
          ${row.invoice_url ? `<a href="${escapeHtml(row.invoice_url)}" target="_blank" rel="noopener">Open payment link</a>` : "<span>The payment link will appear here after creation.</span>"}
        </details>
      </article>`;
    }).join("") : "<p>No payment requests are available for this arrival.</p>";
    updateWorkflowUI();
  }

  function parseDraftLineTitle(value) {
    const title = String(value || "").replace(/^Make Up (?:balance|direct purchase) - /, "").trim();
    const separator = title.indexOf(" - ");
    if (separator < 0) return { code: title || "Product", title: "" };
    return {
      code: title.slice(0, separator).trim(),
      title: title.slice(separator + 3).trim(),
    };
  }

  function mergeDraftLines(lines) {
    const merged = new Map();
    lines.forEach((line) => {
      const parsed = parseDraftLineTitle(line.title);
      const currency = line.originalUnitPriceWithCurrency?.currencyCode || "";
      const amount = Number(line.originalUnitPriceWithCurrency?.amount || 0);
      const key = `${parsed.code}|${parsed.title}|${currency}|${amount}`;
      const current = merged.get(key);
      if (current) current.quantity += Number(line.quantity || 0);
      else merged.set(key, { ...line, quantity: Number(line.quantity || 0) });
    });
    return [...merged.values()];
  }

  refs.draftGroups?.addEventListener("change", (event) => {
    const checkbox = event.target.closest("[data-group-select]");
    if (!checkbox) return;
    if (checkbox.checked) state.selectedGroupIds.add(checkbox.value);
    else state.selectedGroupIds.delete(checkbox.value);
    updateWorkflowUI();
  });

  function renderHistory() {
    refs.history.innerHTML = state.batches.length ? state.batches.map((batch) => `<article><strong>${escapeHtml(batch.source_label || batch.arrival_batch_id)}</strong><span>${escapeHtml(batch.release_id)}</span><span>${escapeHtml(formatDate(batch.arrived_at))}</span><span>${escapeHtml(batch.status)}</span></article>`).join("") : "<p>No arrival batches recorded.</p>";
  }

  function clearPreview() {
    root.dataset.hasSummary = "false";
    refs.previewPanel.hidden = true;
    if (refs.previewIssues) refs.previewIssues.hidden = true;
    refs.record.disabled = true;
    root.querySelectorAll("[data-kob-mac-total]").forEach((element) => { element.textContent = "0"; });
  }

  function renderRecordedAllocationReview(payload) {
    root.dataset.hasSummary = "true";
    if (refs.previewIssues) refs.previewIssues.hidden = true;
    const allocations = (payload.allocations || []).filter((row) => row.status !== "cancelled");
    state.allocations = allocations;
    refs.previewPanel.hidden = false;
    refs.previewRows.innerHTML = (payload.lines || []).map((line) => {
      const lineAllocations = allocations.filter((row) => row.variant_code === line.variant_code);
      const customerQuantity = lineAllocations
        .filter((row) => allocationKind(row) === "customer")
        .reduce((sum, row) => sum + Number(row.quantity || 0), 0);
      const partnerQuantity = lineAllocations
        .filter((row) => allocationKind(row) === "partner")
        .reduce((sum, row) => sum + Number(row.quantity || 0), 0);
      return `<tr>
        <td data-label="Code">${renderModelCode(line.variant_code)}</td>
        <td data-label="Arrived">${number(line.arrived_qty)}</td>
        <td data-label="Customer">${number(customerQuantity)}</td>
        <td data-label="Partner">${number(partnerQuantity)}</td>
        <td data-label="Remainder">${number(line.catalog_inventory_qty)}</td>
        <td data-label="Partner adjustment">Recorded</td>
      </tr>`;
    }).join("");
    renderAllocationCards(allocations);
    const totals = {
      arrived_qty: (payload.lines || []).reduce((sum, row) => sum + Number(row.arrived_qty || 0), 0),
      customer_allocated_now_qty: allocations.filter((row) => row.allocation_kind === "customer").reduce((sum, row) => sum + Number(row.quantity || 0), 0),
      partner_allocated_now_qty: allocations.filter((row) => row.allocation_kind === "partner").reduce((sum, row) => sum + Number(row.quantity || 0), 0),
      available_remainder_qty: (payload.lines || []).reduce((sum, row) => sum + Number(row.catalog_inventory_qty || 0), 0),
      customer_invoice_ready_count: new Set(
        allocations.filter((row) => allocationKind(row) === "customer" && row.pricing_status === "ready").map((row) => row.group_key || row.recipient_email),
      ).size,
      partner_invoice_ready_count: new Set(
        allocations.filter((row) => allocationKind(row) === "partner" && row.pricing_status === "ready").map((row) => row.group_key || row.recipient_email),
      ).size,
      points_to_award: allocations.reduce((sum, row) => sum + Number(row.points_to_award || 0), 0),
    };
    Object.entries(totals).forEach(([key, value]) => {
      const element = root.querySelector(`[data-kob-mac-total="${key}"]`);
      if (element) element.textContent = number(value);
    });
  }

  function openCustomerDetails(email) {
    if (!refs.customerDialog || !refs.customerDialogContent) return;
    const normalizedEmail = String(email || "").trim().toLowerCase();
    const rows = state.allocations.filter((row) => (
      allocationKind(row) === "customer"
      && String(row.recipient_email || "").trim().toLowerCase() === normalizedEmail
      && row.status !== "cancelled"
    ));
    const quantity = rows.reduce((sum, row) => sum + Number(row.quantity || 0), 0);
    const points = rows.reduce((sum, row) => sum + Number(row.points_to_award || 0), 0);
    const balances = new Map();
    rows.forEach((row) => {
      const currency = row.charge_currency || "JPY";
      balances.set(currency, (balances.get(currency) || 0) + Number(row.charge_amount ?? row.balance_due_jpy ?? 0));
    });
    const balanceLabel = [...balances.entries()].map(([currency, amount]) => `${currency} ${number(amount)}`).join(" + ") || "-";
    refs.customerDialogContent.innerHTML = `
      <header class="kob-mac__customer-detail-head">
        <h2>${escapeHtml(customerDisplayName(normalizedEmail, rows[0]))}</h2>
        <p>${escapeHtml(normalizedEmail || "Email missing")}</p>
      </header>
      <div class="kob-mac__customer-detail-summary">
        <div><span>Allocated</span><strong>${number(quantity)}</strong></div>
        <div><span>Balance</span><strong>${escapeHtml(balanceLabel)}</strong></div>
        <div><span>Points after payment</span><strong>${number(points)}</strong></div>
      </div>
      <div class="kob-mac__customer-detail-lines">
        ${rows.map((row) => {
          const details = productDetails(row.variant_code, row.payload?.product_title, row.payload?.product_detail);
          const source = allocationSourceLabel(row);
          return `<article>
            <strong>${escapeHtml(row.variant_code)} · ${escapeHtml(details.title)}</strong>
            ${details.detail ? `<span>${escapeHtml(details.detail)}</span>` : ""}
            <span>${number(row.quantity)} unit${Number(row.quantity) === 1 ? "" : "s"} · ${escapeHtml(row.charge_currency || "JPY")} ${number(row.charge_amount ?? row.balance_due_jpy)} balance · ${number(row.points_to_award)} points</span>
            <span>${source ? `${escapeHtml(source)} · ` : ""}Deposit recorded: JPY ${number(row.deposit_total_jpy || 0)}${row.group_key ? ` · Ref. ${escapeHtml(row.group_key)}` : ""}</span>
            ${(row.issues || []).length ? `<span>${escapeHtml(row.issues.join(", "))}</span>` : ""}
          </article>`;
        }).join("") || "<p>No active customer allocation was found.</p>"}
      </div>`;
    if (typeof refs.customerDialog.showModal === "function") refs.customerDialog.showModal();
    else refs.customerDialog.setAttribute("open", "");
  }

  function closeCustomerDetails() {
    if (!refs.customerDialog) return;
    if (typeof refs.customerDialog.close === "function") refs.customerDialog.close();
    else refs.customerDialog.removeAttribute("open");
  }

  function setLoading(value) {
    state.loading = value;
    root.classList.toggle("is-loading", value);
    [refs.load, refs.refresh, refs.preview, refs.record, refs.prepareDrafts, refs.createDrafts, refs.sendInvoices, refs.trackRefresh, refs.startNext].forEach((button) => {
      if (!button) return;
      button.disabled = value
        || (button === refs.preview && !state.supplierRows.length)
        || (button === refs.record && !state.lastPlan)
        || (button === refs.prepareDrafts && !state.selectedBatchId)
        || (button === refs.createDrafts && (!state.lastDraftPlan || !state.draftWritesEnabled || !draftGroupsCanBeCreated()))
        || (button === refs.sendInvoices && (!state.invoiceSendingEnabled || !(state.lastDraftPlan?.groups || []).some((row) => row.status === "draft_created")));
    });
    updateWorkflowUI();
  }

  function toast(message) {
    window.clearTimeout(state.toastTimer);
    refs.toast.textContent = message;
    refs.toast.classList.add("is-visible");
    if (refs.feedback && root.dataset.view === "batch") {
      refs.feedback.textContent = message;
      refs.feedback.hidden = false;
      refs.feedback.dataset.kind = /unable|failed|could not|error|blocked/i.test(message) ? "error" : "info";
    }
    state.toastTimer = window.setTimeout(() => refs.toast.classList.remove("is-visible"), 4000);
  }

  function escapeHtml(value) { return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;"); }
  function number(value) { return new Intl.NumberFormat("en-US").format(Number(value || 0)); }
  function formatDate(value) { const date = new Date(value); return Number.isNaN(date.valueOf()) ? String(value || "") : date.toLocaleString(); }

  refs.load?.addEventListener("click", load);
  refs.refresh?.addEventListener("click", () => load());
  refs.trackRefresh?.addEventListener("click", async () => {
    if (!state.selectedBatchId) return;
    await load(state.selectedBatchId);
    toast("Payment status refreshed.");
  });
  refs.startNext?.addEventListener("click", startNextArrival);
  refs.preview?.addEventListener("click", preview);
  refs.record?.addEventListener("click", record);
  refs.prepareDrafts?.addEventListener("click", prepareDrafts);
  refs.createDrafts?.addEventListener("click", createDrafts);
  refs.sendInvoices?.addEventListener("click", sendInvoices);
  refs.customerDialogClose?.addEventListener("click", closeCustomerDetails);
  refs.customerDialog?.addEventListener("click", (event) => {
    if (event.target === refs.customerDialog) closeCustomerDetails();
  });
  root.addEventListener("click", (event) => {
    const customerButton = event.target.closest("[data-customer-details]");
    if (customerButton) {
      openCustomerDetails(customerButton.dataset.customerDetails || "");
      return;
    }
    const modelButton = event.target.closest("[data-model-code]");
    root.querySelectorAll("[data-model-code].is-open").forEach((button) => {
      if (button !== modelButton) button.classList.remove("is-open");
    });
    if (modelButton) {
      modelButton.classList.toggle("is-open");
      positionModelPreview(modelButton);
    }
  });
  root.addEventListener("pointerover", (event) => positionModelPreview(event.target.closest?.("[data-model-code]")));
  root.addEventListener("focusin", (event) => positionModelPreview(event.target.closest?.("[data-model-code]")));
  window.addEventListener("scroll", () => {
    root.querySelectorAll("[data-model-code].is-open, [data-model-code]:hover, [data-model-code]:focus-visible")
      .forEach(positionModelPreview);
  }, { passive: true });
  window.addEventListener("resize", () => {
    root.querySelectorAll("[data-model-code].is-open, [data-model-code]:hover, [data-model-code]:focus-visible")
      .forEach(positionModelPreview);
  });
  refs.inputRows?.addEventListener("input", () => { state.lastPlan = null; state.requestId = ""; refs.record.disabled = true; });
  refs.form?.elements?.release_id?.addEventListener("input", () => { state.supplierRows = []; state.lastPlan = null; state.requestId = ""; refs.preview.disabled = true; refs.record.disabled = true; clearPreview(); });
  for (const link of root.querySelectorAll('a[href]')) {
    const url = new URL(link.getAttribute('href'), location.origin === 'null' ? 'https://kind-of-blu.com' : location.origin);
    if (/^\/(?:zh\/|ja\/)?pages\/kob-product-release-control$/.test(url.pathname) && url.origin === location.origin)
      link.setAttribute('href', catalogProductURL({ arrival_line_id: new URL(location.href).searchParams.get('catalog_line') || '' }));
  }
  loadOperations().then(() => {
    const catalogLineId = new URLSearchParams(window.location.search).get("catalog_line");
    if (catalogLineId !== null) return openCatalogLine(catalogLineId);
    const inboxId = new URLSearchParams(window.location.search).get("inbox_id");
    if (inboxId) refs.inboxList?.querySelector(`[data-inbox-id="${CSS.escape(inboxId)}"] [data-review-inbox]`)?.click();
    updateWorkflowUI();
  });
})();

